function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{fill:none;stroke:#397BBF;stroke-width:6;stroke-linecap:square;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st1{fill:#397BBF;}\n\t.st2{display:none;}\n\t.st3{display:inline;}\n");

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  id: "Layer_1"
}, React.createElement("polyline", {
  className: "st0",
  points: "67.8,12.4 67.8,46.2 93.6,33.3 116,46.2 116,12.4  "
}), React.createElement("polyline", {
  className: "st0",
  points: "174,46.2 174,12.4 148.2,27.5 125.8,12.4 125.8,46.2  "
}), React.createElement("polyline", {
  className: "st0",
  points: "227.5,12.4 186,12.4 186,46.2 227.5,46.2 227.5,33.3 209.5,33.3  "
}), React.createElement("polyline", {
  className: "st0",
  points: "239,46.2 239,12.4 278.5,12.4 278.5,27.5 260.5,30.4 278.5,34.5 278.5,46.2  "
}), React.createElement("path", {
  className: "st1",
  d: "M28.1,2.4c0.2,0,0.3,0,0.5,0c0.4,0.2,0.7,0.5,1.1,0.7c7.4,4,14.8,7.9,22.2,11.9c0.7,0.4,1,0.8,1,1.7 c0,8.3,0,16.7,0,25c0,0.8-0.3,1.2-1,1.6c-7.6,4.1-15.2,8.1-22.8,12.2c-0.4,0.2-1.1,0.2-1.5,0c-7.6-4-15.2-8.1-22.8-12.2 c-0.7-0.4-1-0.8-1-1.6c0-8.3,0-16.7,0-25c0-0.9,0.3-1.3,1-1.7c4.9-2.6,9.8-5.2,14.7-7.9C22.4,5.6,25.2,4,28.1,2.4z M10.9,16.8 c0.2,0.2,0.3,0.3,0.4,0.3c5.5,3.1,10.9,6.1,16.4,9.1c0.4,0.2,1.2,0.1,1.6-0.2c3.3-1.8,6.7-3.7,10-5.5c2.1-1.2,4.3-2.4,6.6-3.7 c-5.2-2.8-10.2-5.5-15.4-8.2c0,0.6,0,1,0,1.4c0,2.8-0.1,5.7,0,8.5c0,1.2-0.3,2-1.4,2.6c-1.2,0.6-3-0.4-3-1.7c0-2.3,0-4.5,0-6.8 c0-1.2,0-2.5,0-3.9C21,11.4,16,14.1,10.9,16.8z M48.3,20.8C48,21,47.8,21,47.7,21.1c-5.5,3-10.9,6-16.4,9c-0.6,0.4-0.8,0.8-0.8,1.5 c0,5.7,0,11.3,0,17c0,0.3,0.1,0.6,0.1,1c5.1-2.7,10.1-5.4,15.2-8.2c-0.5-0.3-0.8-0.5-1.2-0.7c-2.9-1.6-5.9-3.2-8.8-4.9 c-0.4-0.2-0.9-0.6-0.9-0.9c-0.1-1.5,0-3,0-4.7c4.5,2.5,8.9,4.8,13.3,7.3C48.3,31.9,48.3,26.4,48.3,20.8z M26,49.6 c0.1-0.4,0.1-0.5,0.1-0.7c0-5.9,0-11.7,0-17.6c0-0.5-0.5-1.1-0.9-1.3c-4.4-2.5-8.8-4.9-13.3-7.3c-1.1-0.6-2.3-1.2-3.5-1.9 c0,5.6,0,11.1,0,16.7c4.4-2.4,8.7-4.8,13.1-7.2c0.7,4.4,0.5,4.9-3.1,6.8c-0.1,0.1-0.3,0.2-0.4,0.2c-2.4,1.3-4.7,2.6-7.3,4 C15.9,44.2,20.9,46.8,26,49.6z"
}));

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "Layer_2",
  className: "st2"
}, React.createElement("g", {
  id: "cUZdh7.tif",
  className: "st3"
}, React.createElement("g", null, React.createElement("path", {
  className: "st1",
  d: "M57.7,28c0,0.2-0.1,0.3-0.1,0.6c0-0.6,0-1.1,0-1.6c0,0.1,0.1,0.1,0.1,0.2C57.7,27.4,57.7,27.7,57.7,28z"
}), React.createElement("path", {
  className: "st1",
  d: "M38.9,37.1c0,0.7-0.6,1.2-1.2,1.2c-0.6,0-1-0.5-1-1c0-0.5,0.5-1.2,1.3-1.2C38.5,36.1,38.9,36.5,38.9,37.1z"
}), React.createElement("path", {
  className: "st1",
  d: "M37.8,33.3c0.6,0,1,0.4,1,1c0,0.7-0.4,1.2-1.2,1.2c-0.6,0-1-0.5-1-1C36.6,33.9,37.1,33.3,37.8,33.3z"
}), React.createElement("path", {
  className: "st1",
  d: "M40.3,35.2c-0.8,0-1.1-0.6-0.9-1.3c0.1-0.7,0.7-1.1,1.5-0.9c0.5,0.1,0.7,0.7,0.6,1.2 C41.3,34.8,40.9,35.2,40.3,35.2z"
}), React.createElement("path", {
  className: "st1",
  d: "M40.7,35.7c0.6,0,0.9,0.3,0.9,0.8c0.1,0.8-0.6,1.4-1.1,1.4c-0.7,0-1.1-0.4-1-0.9 C39.5,36.4,39.8,35.7,40.7,35.7z"
}), React.createElement("path", {
  className: "st1",
  d: "M33.8,34.8c0-0.6,0.6-1.2,1.1-1.2c0.6,0,1,0.4,1,1c0,0.6-0.5,1.1-1.2,1.2C34.3,35.8,33.8,35.4,33.8,34.8z"
}), React.createElement("path", {
  className: "st1",
  d: "M34.9,38.6c-0.7,0.1-1.1-0.5-1.1-1c0-0.5,0.6-1.2,1.2-1.1c0.6,0,1,0.5,1,1C36,38,35.5,38.6,34.9,38.6z"
}), React.createElement("path", {
  className: "st1",
  d: "M41.3,31.1c0.1,0.5-0.5,1.2-1.1,1.2c-0.5,0-1-0.5-1-1.1c0-0.6,0.5-1.2,1.1-1.2C40.8,30,41.3,30.6,41.3,31.1z "
}), React.createElement("path", {
  className: "st1",
  d: "M36.5,31.6c0-0.7,0.5-1.1,1.1-1.1c0.7,0,1,0.5,1,1.3c0,0.4-0.5,1-1.2,1C36.9,32.6,36.5,32.2,36.5,31.6z"
}), React.createElement("path", {
  className: "st1",
  d: "M36.6,40c0-0.6,0.6-1.2,1.3-1.2c0.6,0,1,0.4,1,0.9c0,0.8-0.7,1.2-1.3,1.2C37.1,41,36.5,40.6,36.6,40z"
}), React.createElement("path", {
  className: "st1",
  d: "M44,33.4c0,0.8-0.5,1.3-1.2,1.3c-0.4,0-0.6-0.2-0.7-0.5c-0.4-0.8,0.3-1.9,1.1-1.8C43.7,32.4,44,32.8,44,33.4 z"
}), React.createElement("path", {
  className: "st1",
  d: "M40.2,40.5c-0.4,0.1-0.6-0.2-0.8-0.5c-0.1-0.4,0-0.7,0.2-1c0.3-0.4,0.7-0.6,1.2-0.6c0.4,0,0.7,0.3,0.7,0.7 C41.6,39.8,40.9,40.6,40.2,40.5z"
}), React.createElement("path", {
  className: "st1",
  d: "M44.1,36.1c0.1,0.5-0.4,1.2-1,1.3c-0.5,0.1-1-0.3-1-0.8c0-0.5,0.3-1.1,0.8-1.3C43.5,35,44.2,35.5,44.1,36.1z "
}), React.createElement("path", {
  className: "st1",
  d: "M33.7,40.3c0.1-0.6,0.6-1.1,1.2-1.1c0.3,0,0.6,0,0.9,0.3c0.4,0.3,0.3,1.1-0.2,1.5c-0.5,0.4-1.3,0.4-1.6,0 C33.9,40.7,33.8,40.5,33.7,40.3z"
}), React.createElement("path", {
  className: "st1",
  d: "M41.8,30.8c0-0.7,0.4-1.2,1-1.2c0.6,0,0.9,0.4,1,1.1c0,0.7-0.6,1.2-1.1,1.2C42.2,31.9,41.8,31.4,41.8,30.8z"
}), React.createElement("path", {
  className: "st1",
  d: "M34.8,32.9c-0.6,0.1-1-0.5-1-1c0-0.6,0.5-1.1,1.1-1.1c0.6,0,1,0.5,1,1.1C35.8,32.4,35.3,33,34.8,32.9z"
}), React.createElement("path", {
  className: "st1",
  d: "M30.9,37.7c0-0.6,0.5-1,1.2-1c0.5,0,1,0.4,1,1c0,0.7-0.5,1.1-1.1,1.1C31.4,38.8,30.9,38.2,30.9,37.7z"
}), React.createElement("path", {
  className: "st1",
  d: "M44.1,38.7c-0.1,0.8-0.6,1.3-1.3,1.4c-0.5,0.1-0.9-0.5-0.8-1c0.1-0.5,0.4-1.1,1.1-1.2 C43.7,37.8,44.1,38.1,44.1,38.7z"
}), React.createElement("path", {
  className: "st1",
  d: "M37.4,29.7c-0.5,0-1.1-0.5-1.1-1.1c0-0.6,0.5-1.1,1-1.1c0.5,0,1,0.5,1,1.1C38.4,29.1,37.9,29.7,37.4,29.7z"
}), React.createElement("path", {
  className: "st1",
  d: "M33,34.9c0,0.6-0.4,1-1.1,1c-0.6,0-1-0.4-1-1c0-0.5,0.5-1.1,1.1-1.1C32.5,33.9,33.1,34.3,33,34.9z"
}), React.createElement("path", {
  className: "st1",
  d: "M40.9,28.3c0,0.7-0.4,1.1-1,1.1c-0.6,0-1-0.6-1-1.1c0-0.5,0.5-1.1,1.1-1.1C40.5,27.2,40.9,27.6,40.9,28.3z"
}), React.createElement("path", {
  className: "st1",
  d: "M38.7,42.2c0,0.5-0.3,0.8-0.7,1.1c-0.4,0.2-0.8,0.3-1.2,0c-0.3-0.2-0.4-0.8-0.2-1.1c0.3-0.5,0.9-0.8,1.5-0.6 C38.5,41.5,38.7,41.8,38.7,42.2z"
}), React.createElement("path", {
  className: "st1",
  d: "M44.5,33.1c0-0.7,0.5-1.3,1.1-1.3c0.3,0,0.5,0.1,0.6,0.4c0.4,0.8,0,1.8-0.9,2c-0.4,0.1-0.8-0.4-0.8-0.8 C44.5,33.3,44.5,33.2,44.5,33.1z"
}), React.createElement("path", {
  className: "st1",
  d: "M30.9,40.4c0-0.6,0.5-1,1.1-1c0.6,0,1,0.4,1,0.9c0,0.7-0.4,1-1.1,1.1C31.3,41.4,30.9,41,30.9,40.4z"
}), React.createElement("path", {
  className: "st1",
  d: "M40.6,41c0.3-0.1,0.5,0.1,0.7,0.3c0.2,0.3,0.1,0.7-0.1,1c-0.2,0.3-0.5,0.6-1,0.7c-0.4,0.1-0.7,0-0.9-0.2 c-0.2-0.3-0.2-0.6,0-1C39.6,41.4,40,40.9,40.6,41z"
}), React.createElement("path", {
  className: "st1",
  d: "M46.1,30c0,0.5-0.1,0.9-0.5,1.2c-0.5,0.3-1,0.2-1.3-0.4c-0.3-0.6,0-1.4,0.6-1.7c0.3-0.2,0.8,0,1,0.3 C46,29.6,46.1,29.9,46.1,30z"
}), React.createElement("path", {
  className: "st1",
  d: "M45.4,36.8c-0.5,0-0.8-0.2-0.9-0.7c-0.1-0.6,0.3-1.3,0.9-1.5c0.6-0.2,1.2,0.3,1.1,0.9 c-0.1,0.4-0.2,0.8-0.6,1.1C45.7,36.8,45.5,36.8,45.4,36.8z"
}), React.createElement("path", {
  className: "st1",
  d: "M41.5,27.8c-0.1-0.4,0.2-0.9,0.7-1.1c0.2-0.1,0.8,0.1,0.9,0.3c0.3,0.5,0.3,1.1,0,1.5 c-0.2,0.3-0.6,0.4-0.9,0.3c-0.4-0.1-0.7-0.5-0.7-0.9C41.5,28,41.5,27.9,41.5,27.8z"
}), React.createElement("path", {
  className: "st1",
  d: "M34.7,43.7c-0.6-0.1-0.9-0.3-1-0.8c0-0.2,0.1-0.5,0.2-0.7c0.3-0.4,1-0.7,1.6-0.4c0.6,0.3,0.6,1.1,0,1.5 C35.3,43.5,35,43.6,34.7,43.7z"
}), React.createElement("path", {
  className: "st1",
  d: "M35.7,28.9c0,0.6-0.4,1-1,1c-0.6,0-1-0.4-1-1c0-0.6,0.5-1.1,1-1.1C35.1,27.8,35.7,28.2,35.7,28.9z"
}), React.createElement("path", {
  className: "st1",
  d: "M31.9,33c-0.6,0-1-0.4-1-1c0-0.6,0.4-0.9,1.1-0.9c0.6,0,0.9,0.4,0.9,1C33,32.6,32.6,33,31.9,33z"
}), React.createElement("path", {
  className: "st1",
  d: "M42.6,42.5c-0.7,0-0.8-0.4-0.7-0.9c0.1-0.5,0.8-1.1,1.2-1.1c0.7-0.1,0.9,0.4,0.8,0.9 C43.8,41.9,43.3,42.5,42.6,42.5z"
}), React.createElement("path", {
  className: "st1",
  d: "M44.6,38.7c-0.1-0.5,0.4-1.2,0.9-1.4c0.6-0.2,1,0.1,1,0.7c0,0.5-0.3,1-0.7,1.3c-0.3,0.2-0.6,0.2-0.8,0.1 C44.6,39.3,44.6,39.1,44.6,38.7z"
}), React.createElement("path", {
  className: "st1",
  d: "M45.6,27.3c0,0.6-0.2,0.9-0.7,1.1c-0.4,0.1-0.8-0.1-1-0.5c-0.2-0.5-0.2-1.1,0.2-1.4c0.3-0.3,0.6-0.4,0.9-0.2 c0.3,0.1,0.5,0.4,0.6,0.8C45.6,27.2,45.6,27.3,45.6,27.3z"
}), React.createElement("path", {
  className: "st1",
  d: "M30.1,37.8c0,0.6-0.5,0.9-1,0.9c-0.6,0-1.1-0.4-1.1-1c0-0.5,0.5-1,1-0.9C29.7,36.8,30.1,37.2,30.1,37.8z"
}), React.createElement("path", {
  className: "st1",
  d: "M31.9,43.9c-0.6-0.1-0.9-0.3-1-0.7c-0.1-0.5,0.2-0.9,0.6-1.1c0.3-0.1,0.6,0,0.9,0c0.3,0,0.5,0.3,0.6,0.6 c0.1,0.4,0,0.8-0.4,1C32.4,43.7,32.2,43.8,31.9,43.9z"
}), React.createElement("path", {
  className: "st1",
  d: "M39.5,24.3c0.6-0.1,1,0.5,1,1.1c0,0.5-0.4,1-0.9,1c-0.5,0-1-0.5-1-1.1C38.6,24.7,39,24.3,39.5,24.3z"
}), React.createElement("path", {
  className: "st1",
  d: "M47.4,28.4c0.4-0.1,0.8,0.4,0.9,1c0,0.4-0.1,0.7-0.4,1c-0.4,0.4-0.9,0.3-1.2-0.1c-0.5-0.7-0.1-1.5,0.4-1.8 C47.2,28.5,47.3,28.5,47.4,28.4z"
}), React.createElement("path", {
  className: "st1",
  d: "M48.5,32.1c0,0.7-0.3,1.3-0.8,1.4c-0.3,0.1-0.7,0-0.8-0.3c-0.2-0.6-0.1-1.4,0.4-1.8c0.4-0.3,0.9-0.1,1.1,0.4 C48.5,31.8,48.5,32,48.5,32.1z"
}), React.createElement("path", {
  className: "st1",
  d: "M29.1,34c0.6,0,1,0.4,1,1c0,0.5-0.4,1-1,1c-0.6,0-1-0.4-1-1C28.1,34.5,28.3,34,29.1,34z"
}), React.createElement("path", {
  className: "st1",
  d: "M31.9,28.1c0.6,0,0.9,0.4,1,1c0,0.6-0.4,1-1,1c-0.5,0-1-0.5-1-1C30.9,28.5,31.3,28.1,31.9,28.1z"
}), React.createElement("path", {
  className: "st1",
  d: "M46.9,35.3c0-0.6,0.2-1,0.6-1.3c0.6-0.4,1.1-0.1,1.2,0.6c0,0.4-0.1,0.8-0.4,1.2c-0.2,0.3-0.6,0.4-1,0.3 C46.9,36,46.9,35.6,46.9,35.3z"
}), React.createElement("path", {
  className: "st1",
  d: "M37.1,26.7c-0.6,0-1-0.4-1-1c0-0.6,0.4-0.9,0.9-1c0.4,0,1,0.4,1,1C38,26.2,37.6,26.7,37.1,26.7z"
}), React.createElement("path", {
  className: "st1",
  d: "M37.2,45.7c-0.3,0-0.6-0.1-0.7-0.4c-0.2-0.3-0.1-0.6,0.1-0.9c0.3-0.5,1.1-0.8,1.7-0.5c0.3,0.1,0.4,0.7,0.2,1 C38.2,45.4,37.7,45.6,37.2,45.7z"
}), React.createElement("path", {
  className: "st1",
  d: "M41,24.9c0-0.6,0.4-1,0.9-1c0.6,0,1,0.5,1,1.1c0,0.5-0.3,1-0.9,1C41.5,26,41,25.5,41,24.9z"
}), React.createElement("path", {
  className: "st1",
  d: "M30.1,40.5c0,0.5-0.4,0.9-1,0.9c-0.6,0-1.1-0.4-1-0.9c0-0.6,0.4-0.9,1.1-0.9C29.6,39.5,30.2,39.8,30.1,40.5z "
}), React.createElement("path", {
  className: "st1",
  d: "M39,44.7c0-0.6,0.3-0.9,0.7-1.1c0.3-0.2,0.6-0.4,1-0.2c0.4,0.2,0.6,0.5,0.4,0.9c-0.2,0.7-1,1.1-1.7,0.9 C39.1,45.1,39,44.9,39,44.7z"
}), React.createElement("path", {
  className: "st1",
  d: "M46.3,40.4c0,0.6-0.6,1.4-1.3,1.4c-0.4,0-0.8-0.3-0.7-0.7c0.2-0.6,0.4-1.2,1.1-1.4 C45.9,39.7,46.3,39.9,46.3,40.4z"
}), React.createElement("path", {
  className: "st1",
  d: "M35.8,44.9c0.1,0.5-0.5,0.9-0.9,1c-0.2,0-0.5,0-0.7,0c-0.3-0.1-0.5-0.3-0.5-0.6c0-0.3,0.1-0.6,0.4-0.8 c0.4-0.3,0.9-0.4,1.3-0.2C35.6,44.4,35.8,44.6,35.8,44.9z"
}), React.createElement("path", {
  className: "st1",
  d: "M46.1,26.8c0-0.2,0.1-0.4,0.1-0.5c0.1-0.4,0.5-0.7,0.8-0.7c0.3,0,0.7,0.4,0.8,0.8c0.1,0.5,0.1,0.9-0.3,1.3 c-0.3,0.4-0.9,0.2-1.1-0.2C46.2,27.2,46.1,27,46.1,26.8z"
}), React.createElement("path", {
  className: "st1",
  d: "M29.1,31.1c0.7-0.1,1,0.4,1,0.9c0,0.5-0.3,0.9-0.9,1c-0.6,0-1-0.4-1-0.9C28.1,31.5,28.5,31.1,29.1,31.1z"
}), React.createElement("path", {
  className: "st1",
  d: "M34.4,26.8c-0.6,0-1-0.4-0.9-0.9c0-0.6,0.4-1,0.9-1c0.6,0,1,0.4,1,1C35.4,26.4,35,26.9,34.4,26.8z"
}), React.createElement("path", {
  className: "st1",
  d: "M45.1,24.6c0,0.5-0.3,0.8-0.6,1c-0.2,0.1-0.6,0-0.9-0.3c-0.3-0.4-0.4-1.1,0-1.5c0.3-0.4,1.1-0.3,1.3,0.2 C45,24.1,45,24.3,45.1,24.6z"
}), React.createElement("path", {
  className: "st1",
  d: "M41.6,44.2c-0.1-0.7,0.9-1.4,1.5-1.3c0.4,0.1,0.6,0.3,0.5,0.6c0,0.6-1,1.4-1.6,1.3 C41.7,44.7,41.6,44.5,41.6,44.2z"
}), React.createElement("path", {
  className: "st1",
  d: "M48.6,37.3c0,0.7-0.3,1.2-0.9,1.4c-0.4,0.1-0.7,0-0.8-0.4c-0.2-0.7,0.2-1.4,0.8-1.7 C48.3,36.4,48.7,36.7,48.6,37.3z"
}), React.createElement("path", {
  className: "st1",
  d: "M31.9,46.1c-0.9-0.1-1.3-0.5-1-1.1c0.1-0.2,0.4-0.4,0.6-0.5c0.4-0.1,0.8-0.1,1.1,0.2c0.4,0.3,0.3,1-0.2,1.3 C32.3,46,32.1,46.1,31.9,46.1z"
}), React.createElement("path", {
  className: "st1",
  d: "M29.1,43.8c-0.8,0.1-1.2-0.6-0.9-1.1c0.1-0.2,0.3-0.4,0.5-0.5c0.7-0.2,1.5,0,1.4,0.9c0,0.4-0.4,0.7-0.7,0.7 C29.3,43.8,29.2,43.8,29.1,43.8z"
}), React.createElement("path", {
  className: "st1",
  d: "M50.1,28.8c0,0.4-0.1,0.8-0.5,1.1c-0.3,0.2-0.6,0.1-0.8-0.2c-0.3-0.4-0.3-1.2,0.1-1.7 c0.2-0.2,0.4-0.4,0.7-0.3c0.3,0.1,0.5,0.5,0.5,0.8C50.1,28.6,50.1,28.7,50.1,28.8z"
}), React.createElement("path", {
  className: "st1",
  d: "M30.9,26c0-0.6,0.4-0.9,0.9-0.9c0.5,0,1,0.4,1,0.9c0,0.5-0.4,0.9-1,0.9C31.3,27,30.8,26.6,30.9,26z"
}), React.createElement("path", {
  className: "st1",
  d: "M50.5,31.5c0,0.4-0.1,0.8-0.4,1.1c-0.4,0.3-0.8,0.2-1-0.2c-0.3-0.6-0.1-1.1,0.3-1.6c0.2-0.3,0.5-0.3,0.7-0.2 c0.2,0.1,0.3,0.4,0.4,0.6C50.5,31.2,50.4,31.3,50.5,31.5z"
}), React.createElement("path", {
  className: "st1",
  d: "M46.4,25c-0.5,0-0.8-0.3-0.8-0.6c-0.1-0.3-0.1-0.7,0-1c0.1-0.4,0.5-0.6,1-0.4c0.4,0.2,0.6,0.6,0.6,1 c0,0.3-0.1,0.7-0.4,0.9C46.6,24.9,46.5,25,46.4,25z"
}), React.createElement("path", {
  className: "st1",
  d: "M40,22.5c0.1,0.6-0.4,0.9-0.8,0.9c-0.6,0-1-0.4-1-1c0-0.5,0.3-0.9,0.8-0.9C39.4,21.4,40,21.9,40,22.5z"
}), React.createElement("path", {
  className: "st1",
  d: "M30,29.1c0,0.6-0.4,1-0.9,1c-0.5,0-1-0.5-1-1c0-0.4,0.3-0.9,0.9-0.9C29.6,28.2,30,28.5,30,29.1z"
}), React.createElement("path", {
  className: "st1",
  d: "M50,33.1c0.3,0,0.6,0.2,0.6,0.8c0,0.6-0.1,1.1-0.7,1.4c-0.2,0.1-0.5,0.1-0.7-0.1c-0.2-0.3-0.3-0.6-0.2-0.9 c0.1-0.4,0.2-0.8,0.6-1C49.8,33.2,49.9,33.2,50,33.1z"
}), React.createElement("path", {
  className: "st1",
  d: "M48.4,39.7c0,0.6-0.5,1.3-1,1.4c-0.2,0-0.4,0-0.5-0.1c-0.1-0.1-0.3-0.4-0.2-0.6c0.1-0.4,0.3-0.8,0.6-1.1 c0.1-0.1,0.2-0.2,0.4-0.2C48,39,48.5,39.1,48.4,39.7z"
}), React.createElement("path", {
  className: "st1",
  d: "M44.6,44.1c-0.5,0-0.7-0.3-0.5-0.7c0.2-0.6,0.6-1,1.2-1.2c0.4-0.1,0.7,0.2,0.7,0.5 C46,43.3,45.2,44.2,44.6,44.1z"
}), React.createElement("path", {
  className: "st1",
  d: "M27.1,37.7c0,0.5-0.4,0.9-0.9,0.9c-0.5,0-1-0.4-1-0.9c0-0.5,0.3-0.9,0.9-0.9C26.7,36.8,27,37.2,27.1,37.7z"
}), React.createElement("path", {
  className: "st1",
  d: "M41.4,23c-0.6,0-0.9-0.4-0.9-1c0-0.5,0.3-0.9,0.8-0.9c0.6,0,1,0.5,1,1.1C42.2,22.7,42,23,41.4,23z"
}), React.createElement("path", {
  className: "st1",
  d: "M26.2,35.8c-0.6,0-1-0.3-0.9-0.9c0-0.6,0.4-0.8,0.9-0.8c0.5,0,1,0.4,1,0.9C27.1,35.4,26.8,35.8,26.2,35.8z"
}), React.createElement("path", {
  className: "st1",
  d: "M48.1,26c-0.1-0.4,0.1-0.7,0.4-0.9c0.3-0.2,0.7-0.1,0.9,0.3c0.2,0.4,0.2,1.2,0,1.5c-0.3,0.4-0.8,0.4-1.1,0 C48.2,26.6,48.2,26.3,48.1,26C48.1,26.1,48.1,26,48.1,26z"
}), React.createElement("path", {
  className: "st1",
  d: "M35.8,22.7c0-0.5,0.4-0.9,0.8-0.9c0.5,0,1,0.4,1,1c0,0.5-0.4,0.9-0.9,0.9C36.2,23.7,35.7,23.3,35.8,22.7z"
}), React.createElement("path", {
  className: "st1",
  d: "M37.6,46.1c0.3,0,0.6,0.1,0.7,0.4c0.1,0.3-0.1,0.7-0.4,0.9c-0.4,0.3-0.8,0.4-1.3,0.2 c-0.3-0.1-0.4-0.3-0.3-0.6C36.2,46.5,36.9,46.1,37.6,46.1z"
}), React.createElement("path", {
  className: "st1",
  d: "M40.2,45.7c0.2,0,0.4,0,0.6,0.2c0.1,0.3,0.1,0.5-0.1,0.7c-0.3,0.4-0.7,0.7-1.3,0.7c-0.3,0-0.5,0-0.6-0.3 c-0.2-0.3,0-0.5,0.1-0.8C39.2,45.9,39.6,45.6,40.2,45.7z"
}), React.createElement("path", {
  className: "st1",
  d: "M27.1,40.4c0,0.5-0.4,0.8-0.9,0.9c-0.5,0-1-0.5-1-0.9c0-0.4,0.4-0.8,0.9-0.8C26.6,39.5,27.1,39.9,27.1,40.4z "
}), React.createElement("path", {
  className: "st1",
  d: "M34.2,23.8c-0.5,0.1-0.9-0.5-0.9-0.9c0-0.5,0.4-0.8,0.9-0.9c0.5,0,0.9,0.4,0.9,0.9 C35.1,23.5,34.7,23.9,34.2,23.8z"
}), React.createElement("path", {
  className: "st1",
  d: "M42.7,21.5c0-0.6,0.2-0.8,0.7-0.8c0.6,0,0.9,0.4,0.9,1.1c0,0.5-0.3,0.8-0.7,0.8 C43.1,22.6,42.7,22.1,42.7,21.5z"
}), React.createElement("path", {
  className: "st1",
  d: "M49,37.3c0-0.7,0.3-1.3,0.9-1.5c0.3-0.1,0.6,0,0.6,0.3c0.2,0.6-0.2,1.5-0.8,1.8c-0.4,0.2-0.7,0-0.7-0.5 C49,37.4,49,37.3,49,37.3z"
}), React.createElement("path", {
  className: "st1",
  d: "M34.4,47.9c-0.1,0-0.3,0-0.4,0c-0.5-0.1-0.6-0.5-0.4-1c0.2-0.4,1.1-0.8,1.7-0.4c0.4,0.2,0.4,0.6,0.2,0.9 C35.2,47.8,34.8,48,34.4,47.9z"
}), React.createElement("path", {
  className: "st1",
  d: "M29.1,44.5c0.2,0.1,0.5,0.2,0.7,0.3c0.2,0.2,0.3,0.4,0.2,0.7c-0.1,0.4-0.4,0.5-0.7,0.6c-0.3,0-0.6,0-0.8-0.1 c-0.4-0.1-0.5-0.4-0.5-0.7c0.1-0.4,0.4-0.6,0.7-0.7C28.9,44.6,29,44.6,29.1,44.5C29.1,44.5,29.1,44.5,29.1,44.5z"
}), React.createElement("path", {
  className: "st1",
  d: "M26.2,32.9c-0.5,0.1-0.9-0.4-0.9-0.8c0-0.5,0.4-0.9,0.9-0.9c0.5,0,0.9,0.4,0.9,0.9 C27.1,32.5,26.7,33,26.2,32.9z"
}), React.createElement("path", {
  className: "st1",
  d: "M42.7,45.1c0.6-0.1,0.6,0.3,0.5,0.7c-0.2,0.6-1,1.2-1.6,1c-0.3-0.1-0.5-0.4-0.3-0.7 C41.5,45.6,42.2,45,42.7,45.1z"
}), React.createElement("path", {
  className: "st1",
  d: "M48.4,24.3c-0.4,0-0.8-0.2-0.9-0.5c-0.1-0.4-0.1-0.7,0-1.1c0.1-0.4,0.6-0.5,0.9-0.3c0.6,0.3,0.7,1.5,0.3,1.8 C48.6,24.3,48.5,24.3,48.4,24.3z"
}), React.createElement("path", {
  className: "st1",
  d: "M52.3,30.7c-0.1,0.4-0.2,0.8-0.5,1.1c-0.1,0.1-0.4,0.2-0.5,0.2c-0.2-0.1-0.4-0.3-0.4-0.5 c-0.1-0.5-0.1-1,0.2-1.4c0.1-0.2,0.3-0.4,0.6-0.4c0.2,0,0.3,0.3,0.5,0.4C52.2,30.3,52.2,30.5,52.3,30.7z"
}), React.createElement("path", {
  className: "st1",
  d: "M44.7,21c0-0.5,0.2-0.8,0.6-0.8c0.5,0,0.9,0.3,1,0.8c0,0.1,0,0.3,0,0.4c-0.1,0.4-0.2,0.7-0.5,0.7 c-0.3,0.1-0.7-0.2-0.9-0.5C44.8,21.4,44.8,21.2,44.7,21z"
}), React.createElement("path", {
  className: "st1",
  d: "M32.9,47.3c0,0.4-0.3,0.6-0.6,0.7c-0.4,0.2-0.8,0.2-1.2-0.1c-0.3-0.2-0.4-0.5-0.2-0.8 c0.3-0.4,1.3-0.6,1.7-0.3C32.7,46.9,32.8,47.1,32.9,47.3z"
}), React.createElement("path", {
  className: "st1",
  d: "M27.1,43c0,0.5-0.3,0.7-0.8,0.8c-0.6,0-1-0.4-1-0.8c0-0.4,0.4-0.8,0.9-0.8C26.7,42.1,27.1,42.4,27.1,43z"
}), React.createElement("path", {
  className: "st1",
  d: "M50.4,28.2c0.1-0.3,0.2-0.6,0.3-0.8c0.2-0.4,0.7-0.4,0.9,0c0.3,0.5,0.3,1.3-0.1,1.8 c-0.2,0.2-0.6,0.2-0.8-0.1C50.6,28.7,50.5,28.4,50.4,28.2z"
}), React.createElement("path", {
  className: "st1",
  d: "M29.1,27c-0.5,0-0.9-0.4-0.9-0.9c0-0.5,0.4-0.8,0.9-0.8c0.5,0,0.9,0.4,0.9,0.9C30,26.6,29.5,27,29.1,27z"
}), React.createElement("path", {
  className: "st1",
  d: "M48,41.9c0,0.7-0.7,1.4-1.3,1.5c-0.2,0.1-0.4-0.1-0.5-0.4c0-0.4,0.1-0.8,0.4-1.1c0.2-0.2,0.4-0.5,0.8-0.6 C47.9,41.4,48,41.5,48,41.9z"
}), React.createElement("path", {
  className: "st1",
  d: "M48.8,39.8c0-0.6,0.5-1.3,1-1.5c0.3-0.1,0.5,0,0.5,0.3c0.1,0.7-0.3,1.5-0.9,1.7c-0.4,0.2-0.6,0-0.6-0.4 C48.8,39.9,48.8,39.8,48.8,39.8z"
}), React.createElement("path", {
  className: "st1",
  d: "M52.3,33.2c0.1,0.4-0.1,0.7-0.3,1c-0.1,0.1-0.4,0.3-0.6,0.3c-0.2,0-0.3-0.2-0.4-0.4c-0.1-0.6,0-1.1,0.4-1.5 c0.2-0.2,0.4-0.3,0.6-0.2c0.2,0.1,0.3,0.3,0.3,0.5C52.3,33,52.3,33.1,52.3,33.2z"
}), React.createElement("path", {
  className: "st1",
  d: "M50.5,24.3c0.4,0,0.6,0.3,0.6,0.5c0.2,0.4,0.3,0.8,0,1.2c-0.1,0.2-0.3,0.4-0.4,0.4c-0.2,0-0.4-0.1-0.5-0.2 c-0.3-0.3-0.3-0.6-0.3-1c0-0.2,0.1-0.4,0.2-0.6C50.2,24.5,50.4,24.4,50.5,24.3z"
}), React.createElement("path", {
  className: "st1",
  d: "M27.1,29c0,0.5-0.3,0.9-0.8,0.9c-0.5,0-0.9-0.4-0.9-0.9c0-0.4,0.4-0.8,0.9-0.8C26.7,28.2,27.1,28.5,27.1,29z "
}), React.createElement("path", {
  className: "st1",
  d: "M31.6,23.9c-0.5,0-0.9-0.4-0.9-0.8c0-0.5,0.4-0.8,0.9-0.8c0.5,0,0.8,0.3,0.8,0.8 C32.5,23.6,32.2,23.9,31.6,23.9z"
}), React.createElement("path", {
  className: "st1",
  d: "M38.4,18.7c0.6,0,0.9,0.4,0.9,0.9c0,0.4-0.4,0.8-0.7,0.8c-0.5,0-1-0.5-1-1C37.7,19,38,18.7,38.4,18.7z"
}), React.createElement("path", {
  className: "st1",
  d: "M45.4,44.8c0,0.5-0.5,1.1-1,1.3c-0.2,0.1-0.4,0.1-0.6,0.1c-0.2-0.1-0.3-0.3-0.2-0.5c0.2-0.5,0.6-0.9,1.1-1.2 C45.1,44.3,45.5,44.5,45.4,44.8z"
}), React.createElement("path", {
  className: "st1",
  d: "M41.5,19.4c0.1,0.4-0.2,0.7-0.7,0.8c-0.5,0-1-0.5-1-1c0-0.4,0.2-0.7,0.7-0.7C41.1,18.4,41.5,18.8,41.5,19.4z "
}), React.createElement("path", {
  className: "st1",
  d: "M43.5,18.9c0,0.7-0.5,1-1,0.8c-0.5-0.2-0.8-0.9-0.6-1.3c0.3-0.5,0.9-0.6,1.3-0.1 C43.4,18.5,43.5,18.8,43.5,18.9z"
}), React.createElement("path", {
  className: "st1",
  d: "M47.5,21.5c-0.4,0.1-0.8-0.5-0.9-1c0-0.2,0-0.4,0.1-0.5c0.2-0.4,0.5-0.5,0.9-0.3c0.5,0.3,0.7,1,0.5,1.5 C47.9,21.5,47.8,21.5,47.5,21.5z"
}), React.createElement("path", {
  className: "st1",
  d: "M52.3,35.6c-0.1,0.6-0.2,1.1-0.8,1.5c-0.2,0.2-0.4,0.1-0.5-0.2c-0.3-0.6,0.2-1.6,0.6-1.9 c0.3-0.2,0.5-0.1,0.6,0.3C52.3,35.3,52.3,35.5,52.3,35.6z"
}), React.createElement("path", {
  className: "st1",
  d: "M36.3,20.7c-0.5,0-0.9-0.4-0.9-0.9c0-0.6,0.4-0.8,0.8-0.8c0.5,0,0.9,0.4,0.9,0.9 C37.1,20.4,36.8,20.7,36.3,20.7z"
}), React.createElement("path", {
  className: "st1",
  d: "M50.7,22.9c-0.1,0.2-0.2,0.5-0.3,0.6c-0.1,0.2-0.4,0.2-0.5,0.1c-0.5-0.3-0.8-1.1-0.4-1.7 c0.2-0.4,0.6-0.4,0.9-0.1C50.5,22.2,50.6,22.5,50.7,22.9C50.6,22.9,50.6,22.9,50.7,22.9z"
}), React.createElement("path", {
  className: "st1",
  d: "M23.3,38.4c-0.5,0-0.9-0.4-0.9-0.9c0-0.4,0.3-0.8,0.8-0.7c0.5,0,0.9,0.4,0.9,0.8 C24.1,38.1,23.8,38.4,23.3,38.4z"
}), React.createElement("path", {
  className: "st1",
  d: "M28.9,48.2c-0.2-0.1-0.4-0.1-0.6-0.3c-0.3-0.2-0.3-0.6,0-0.9c0.3-0.3,1.2-0.3,1.5,0c0.2,0.2,0.3,0.4,0.2,0.6 c-0.1,0.2-0.3,0.4-0.5,0.5C29.4,48.2,29.2,48.1,28.9,48.2z"
}), React.createElement("path", {
  className: "st1",
  d: "M24.1,34.8c0,0.4-0.4,0.8-0.8,0.8c-0.5,0-0.9-0.4-0.9-0.9c0-0.4,0.4-0.8,0.8-0.8 C23.7,33.9,24.2,34.4,24.1,34.8z"
}), React.createElement("path", {
  className: "st1",
  d: "M26.3,46c-0.3,0-0.5-0.1-0.8-0.3c-0.3-0.3-0.3-0.7,0.1-1c0.4-0.3,1.2-0.1,1.4,0.3c0.1,0.2,0.2,0.4,0,0.7 c-0.1,0.2-0.3,0.3-0.6,0.3C26.4,46,26.4,46,26.3,46z"
}), React.createElement("path", {
  className: "st1",
  d: "M34.1,49.8c-0.1,0-0.2,0-0.2,0c-0.2-0.1-0.5-0.1-0.6-0.5c0-0.2,0.2-0.6,0.5-0.7c0.4-0.1,0.8-0.2,1.2-0.1 c0.4,0.1,0.5,0.5,0.2,0.8C34.9,49.7,34.5,49.8,34.1,49.8z"
}), React.createElement("path", {
  className: "st1",
  d: "M36.5,49.5c-0.1,0-0.3,0-0.4,0c-0.3-0.1-0.3-0.4-0.2-0.7c0.3-0.5,1.2-0.8,1.7-0.6c0.5,0.2,0.4,0.6,0,0.9 C37.3,49.4,37,49.5,36.5,49.5z"
}), React.createElement("path", {
  className: "st1",
  d: "M38.8,49.2c-0.1-0.1-0.3-0.1-0.4-0.3c-0.1-0.1,0-0.4,0.1-0.5c0.4-0.5,0.9-0.7,1.5-0.6c0.1,0,0.3,0.2,0.3,0.2 c0,0.2,0,0.5-0.1,0.6C39.9,48.9,39.4,49.1,38.8,49.2z"
}), React.createElement("path", {
  className: "st1",
  d: "M33.9,20.8c-0.5,0-0.9-0.4-0.9-0.8c0-0.4,0.4-0.8,0.8-0.8c0.4,0,0.9,0.4,0.9,0.9 C34.7,20.5,34.4,20.8,33.9,20.8z"
}), React.createElement("path", {
  className: "st1",
  d: "M43.9,18.4c0-0.8,0.4-1,1-0.7c0.3,0.2,0.6,0.5,0.6,1c0,0.6-0.5,0.9-1,0.6C44,19,43.9,18.6,43.9,18.4z"
}), React.createElement("path", {
  className: "st1",
  d: "M49.9,41.1c0,0.6-0.6,1.4-1.2,1.5c-0.2,0.1-0.4-0.1-0.4-0.4c0-0.7,0.5-1.4,1.2-1.6 C49.8,40.5,49.9,40.7,49.9,41.1z"
}), React.createElement("path", {
  className: "st1",
  d: "M23.3,41c-0.5,0-0.9-0.4-0.9-0.8c0-0.4,0.3-0.7,0.7-0.7c0.5,0,1,0.4,1,0.8C24.1,40.8,23.8,41,23.3,41z"
}), React.createElement("path", {
  className: "st1",
  d: "M52.1,27.3c0.1-0.2,0.1-0.5,0.2-0.7c0.1-0.1,0.3-0.3,0.4-0.3c0.2,0,0.4,0.2,0.4,0.3c0.2,0.5,0.3,1.1,0,1.6 c-0.2,0.3-0.5,0.3-0.7,0.1C52.2,28,52.1,27.7,52.1,27.3z"
}), React.createElement("path", {
  className: "st1",
  d: "M29.1,23.9c-0.5,0-0.8-0.3-0.8-0.8c0-0.5,0.3-0.8,0.8-0.7c0.5,0,0.8,0.3,0.8,0.7 C29.8,23.6,29.6,23.9,29.1,23.9z"
}), React.createElement("path", {
  className: "st1",
  d: "M23.4,32.7c-0.5,0-0.8-0.4-0.8-0.8c0-0.5,0.3-0.8,0.8-0.8c0.5,0,0.8,0.2,0.8,0.8 C24.1,32.4,23.8,32.7,23.4,32.7z"
}), React.createElement("path", {
  className: "st1",
  d: "M41.1,48.7c-0.1-0.1-0.3-0.2-0.3-0.3c0-0.1,0-0.4,0.1-0.5c0.3-0.4,0.6-0.7,1.2-0.8c0.2,0,0.5-0.1,0.6,0.1 c0.1,0.2,0,0.5-0.1,0.6C42.2,48.4,41.8,48.6,41.1,48.7z"
}), React.createElement("path", {
  className: "st1",
  d: "M47.5,44.1c0,0.6-0.8,1.4-1.4,1.4c-0.2,0-0.4-0.1-0.4-0.4c0.1-0.6,0.4-0.9,0.8-1.2c0.1-0.1,0.2-0.1,0.3-0.2 C47.3,43.6,47.5,43.7,47.5,44.1z"
}), React.createElement("path", {
  className: "st1",
  d: "M52.5,30.2c0-0.5,0.1-1,0.5-1.3c0.2-0.1,0.3-0.1,0.4,0c0.4,0.4,0.3,1.7-0.1,2c-0.3,0.2-0.6,0.1-0.7-0.3 C52.6,30.5,52.6,30.3,52.5,30.2z"
}), React.createElement("path", {
  className: "st1",
  d: "M26.3,26.8c-0.6,0.1-0.8-0.4-0.8-0.8c0-0.4,0.3-0.8,0.8-0.8c0.5,0,0.9,0.3,0.8,0.8 C27.1,26.5,26.9,26.9,26.3,26.8z"
}), React.createElement("path", {
  className: "st1",
  d: "M49.7,20.3c0,0.1,0,0.2,0,0.3c-0.1,0.4-0.5,0.5-0.9,0.2c-0.3-0.3-0.5-1-0.4-1.4c0.1-0.4,0.5-0.5,0.9-0.2 C49.6,19.5,49.7,19.8,49.7,20.3z"
}), React.createElement("path", {
  className: "st1",
  d: "M52.8,24.6c-0.1,0.3-0.1,0.6-0.2,0.8c-0.1,0.3-0.5,0.4-0.8,0.1c-0.3-0.5-0.5-1-0.2-1.6 c0.2-0.4,0.6-0.4,0.8,0C52.6,24.1,52.7,24.4,52.8,24.6z"
}), React.createElement("path", {
  className: "st1",
  d: "M31.6,50c-0.2-0.1-0.4-0.1-0.6-0.2c-0.3-0.1-0.3-0.5-0.1-0.7c0.3-0.4,1-0.4,1.4-0.3c0.2,0.1,0.4,0.2,0.5,0.5 c0,0.3-0.2,0.5-0.4,0.6C32.1,49.9,31.8,49.9,31.6,50z"
}), React.createElement("path", {
  className: "st1",
  d: "M52.1,37.8c-0.1,0.7-0.3,1.2-0.8,1.6c-0.3,0.2-0.6,0.1-0.6-0.3c0-0.6,0.2-1.2,0.7-1.6 c0.1-0.1,0.4-0.2,0.5-0.1C52,37.5,52,37.7,52.1,37.8z"
}), React.createElement("path", {
  className: "st1",
  d: "M23.2,42.1c0.7,0,1.1,0.5,0.9,1c-0.1,0.3-0.4,0.4-0.9,0.4c-0.5,0-0.9-0.6-0.7-1.1 C22.7,42.1,22.9,42.1,23.2,42.1z"
}), React.createElement("path", {
  className: "st1",
  d: "M53.8,32.3c-0.1,0.5-0.1,0.9-0.5,1.3c-0.2,0.2-0.5,0.1-0.6-0.1c-0.1-0.6-0.1-1.1,0.2-1.6 c0.1-0.2,0.3-0.3,0.5-0.3c0.1,0,0.2,0.3,0.3,0.4C53.8,32,53.8,32.2,53.8,32.3z"
}), React.createElement("path", {
  className: "st1",
  d: "M47,18.1c0,0.2,0,0.5-0.3,0.6c-0.3,0.1-0.5,0-0.7-0.2c-0.4-0.3-0.4-0.7-0.4-1.2c0.1-0.4,0.5-0.5,0.9-0.2 C46.9,17.4,47,17.7,47,18.1z"
}), React.createElement("path", {
  className: "st1",
  d: "M52,22.1c0,0.2,0,0.4-0.1,0.6c-0.1,0.3-0.5,0.4-0.8,0.1c-0.3-0.4-0.5-0.8-0.3-1.4c0.1-0.2,0.2-0.4,0.4-0.5 c0.3-0.1,0.5,0.1,0.6,0.4C51.9,21.6,52,21.9,52,22.1z"
}), React.createElement("path", {
  className: "st1",
  d: "M31.4,19.4c0.5,0,0.8,0.3,0.8,0.7c0,0.4-0.4,0.8-0.8,0.8c-0.4,0-0.8-0.4-0.8-0.8 C30.7,19.7,31,19.4,31.4,19.4z"
}), React.createElement("path", {
  className: "st1",
  d: "M43.4,48.1c-0.3,0-0.5-0.2-0.3-0.5c0.3-0.6,0.8-0.9,1.4-1.1c0.3-0.1,0.5,0.2,0.4,0.5 C44.7,47.4,43.8,48.1,43.4,48.1z"
}), React.createElement("path", {
  className: "st1",
  d: "M38.6,16.9c0,0.4-0.2,0.7-0.6,0.7c-0.5,0-0.9-0.4-0.9-0.9c0-0.4,0.3-0.7,0.6-0.7 C38.2,16.1,38.6,16.4,38.6,16.9z"
}), React.createElement("path", {
  className: "st1",
  d: "M26.4,48.1c-0.4-0.1-0.8-0.2-1-0.6c0-0.1,0-0.3,0-0.4c0.4-0.6,1.4-0.4,1.7,0.2c0.1,0.2,0,0.5-0.2,0.6 C26.8,48,26.6,48.1,26.4,48.1z"
}), React.createElement("path", {
  className: "st1",
  d: "M40,17.2c-0.5,0-0.9-0.4-0.9-0.9c0-0.4,0.3-0.7,0.6-0.7c0.5,0,0.9,0.4,0.9,0.9C40.7,17,40.4,17.2,40,17.2z"
}), React.createElement("path", {
  className: "st1",
  d: "M22.7,28.9c0-0.4,0.3-0.7,0.7-0.7c0.5,0,0.8,0.3,0.8,0.8c0,0.4-0.4,0.8-0.8,0.8 C23.1,29.7,22.7,29.3,22.7,28.9z"
}), React.createElement("path", {
  className: "st1",
  d: "M42,16.9c-0.6,0-1.1-0.6-0.9-1.2c0.1-0.3,0.3-0.4,0.6-0.4c0.6,0,1,0.8,0.8,1.3C42.3,16.9,42.2,17,42,16.9z"
}), React.createElement("path", {
  className: "st1",
  d: "M52.6,35.6c0-0.5,0.2-1,0.5-1.4c0.1-0.1,0.3-0.2,0.4-0.2c0.1,0,0.2,0.2,0.2,0.3c0.1,0.6-0.1,1.2-0.5,1.7 c-0.1,0.1-0.3,0.2-0.4,0.2c-0.1-0.1-0.2-0.3-0.2-0.4C52.6,35.7,52.6,35.6,52.6,35.6z"
}), React.createElement("path", {
  className: "st1",
  d: "M35.8,17.8c-0.5,0-0.8-0.4-0.8-0.8c0-0.4,0.3-0.7,0.7-0.7c0.4,0,0.9,0.4,0.8,0.8 C36.5,17.5,36.3,17.7,35.8,17.8z"
}), React.createElement("path", {
  className: "st1",
  d: "M50.1,18.4c0.5,0.1,0.7,0.4,0.8,0.7c0.1,0.2,0.1,0.5,0.1,0.8c-0.1,0.4-0.4,0.5-0.7,0.2 c-0.4-0.3-0.6-1-0.4-1.5C49.9,18.6,50,18.5,50.1,18.4z"
}), React.createElement("path", {
  className: "st1",
  d: "M47.2,17.1c0-0.2,0-0.5,0.3-0.6c0.3-0.1,0.5,0,0.7,0.2c0.3,0.3,0.5,0.6,0.4,1c0,0.2-0.1,0.4-0.2,0.5 c-0.2,0.1-0.4,0-0.6-0.1C47.4,17.9,47.2,17.5,47.2,17.1z"
}), React.createElement("path", {
  className: "st1",
  d: "M23.5,45.9c-0.2-0.1-0.5-0.2-0.7-0.4c-0.2-0.2-0.3-0.5-0.1-0.8c0.1-0.2,0.6-0.3,0.9-0.2 c0.1,0,0.2,0.1,0.3,0.2c0.2,0.2,0.4,0.4,0.3,0.7C24.1,45.7,23.9,45.8,23.5,45.9z"
}), React.createElement("path", {
  className: "st1",
  d: "M42.8,15.5c0-0.4,0.3-0.7,0.8-0.5c0.4,0.1,0.7,0.5,0.7,0.9c0,0.2-0.1,0.4-0.2,0.5c-0.2,0.2-0.5,0.1-0.7,0 C43.1,16.3,42.8,15.9,42.8,15.5z"
}), React.createElement("path", {
  className: "st1",
  d: "M26.4,23.8c-0.4,0-0.8-0.4-0.8-0.8c0-0.3,0.4-0.8,0.8-0.7c0.4,0,0.8,0.3,0.7,0.7 C27.2,23.5,26.8,23.8,26.4,23.8z"
}), React.createElement("path", {
  className: "st1",
  d: "M50.3,41.8c-0.1-0.9,0.2-1.5,0.8-1.9c0.1-0.1,0.3-0.1,0.4-0.1c0.1,0,0.2,0.2,0.1,0.3 c-0.1,0.6-0.3,1.1-0.8,1.5C50.7,41.7,50.5,41.7,50.3,41.8z"
}), React.createElement("path", {
  className: "st1",
  d: "M47.8,44.7c-0.1-0.9,0.7-1.8,1.5-1.7C49.5,43.7,48.7,44.7,47.8,44.7z"
}), React.createElement("path", {
  className: "st1",
  d: "M29.1,48.8c0.1,0,0.3,0,0.4,0.1c0.2,0.1,0.4,0.1,0.5,0.4c0,0.3-0.1,0.5-0.4,0.5c-0.3,0.1-0.7,0.1-1,0 c-0.3,0-0.5-0.2-0.4-0.5c0.1-0.3,0.3-0.4,0.6-0.5C28.8,48.8,29,48.9,29.1,48.8C29.1,48.9,29.1,48.8,29.1,48.8z"
}), React.createElement("path", {
  className: "st1",
  d: "M54.6,26.6c-0.1,0.3-0.1,0.6-0.3,0.8c-0.1,0.2-0.4,0.2-0.5,0c-0.3-0.6-0.4-1.1-0.1-1.7 c0-0.1,0.2-0.2,0.3-0.2c0.1,0,0.3,0.1,0.4,0.2C54.5,25.9,54.6,26.2,54.6,26.6z"
}), React.createElement("path", {
  className: "st1",
  d: "M54,24.2c0,0.2-0.1,0.4-0.2,0.6c-0.1,0.2-0.4,0.2-0.5,0c-0.3-0.5-0.5-1.1-0.2-1.7c0.1-0.2,0.3-0.3,0.5-0.1 C53.9,23.2,54,23.7,54,24.2z"
}), React.createElement("path", {
  className: "st1",
  d: "M36.2,51.1c-0.1,0-0.3,0-0.4-0.1c-0.2-0.1-0.3-0.3-0.2-0.4c0.2-0.4,1.2-0.8,1.6-0.6c0.1,0,0.3,0.2,0.3,0.3 c0,0.2-0.1,0.3-0.2,0.4C36.9,51,36.6,51.1,36.2,51.1z"
}), React.createElement("path", {
  className: "st1",
  d: "M29,20.9c-0.4,0-0.7-0.3-0.7-0.7c0-0.4,0.3-0.7,0.7-0.7c0.4,0,0.8,0.3,0.7,0.7C29.8,20.6,29.5,20.9,29,20.9z "
}), React.createElement("path", {
  className: "st1",
  d: "M34.3,17.3c0,0.4-0.2,0.6-0.7,0.6c-0.5,0-0.8-0.3-0.8-0.7c0-0.3,0.3-0.7,0.7-0.7 C33.9,16.5,34.4,16.9,34.3,17.3z"
}), React.createElement("path", {
  className: "st1",
  d: "M45.4,47.4c-0.3,0-0.3-0.2-0.2-0.4c0.1-0.5,0.5-0.8,0.8-1c0.2-0.1,0.4-0.2,0.5-0.2c0.2-0.1,0.4,0.1,0.3,0.3 C46.8,46.6,45.9,47.4,45.4,47.4z"
}), React.createElement("path", {
  className: "st1",
  d: "M45.4,16c-0.6,0.1-1.1-0.8-0.8-1.3c0.1-0.2,0.2-0.3,0.4-0.2c0.4,0,0.9,0.6,0.9,1C45.9,15.9,45.8,16,45.4,16z "
}), React.createElement("path", {
  className: "st1",
  d: "M33.9,51.3c-0.2,0-0.3,0-0.4,0c-0.1-0.1-0.3-0.1-0.4-0.3c0-0.1,0-0.3,0.1-0.4c0.4-0.4,1.1-0.6,1.6-0.3 c0.3,0.1,0.3,0.5,0.1,0.6C34.6,51.2,34.3,51.4,33.9,51.3z"
}), React.createElement("path", {
  className: "st1",
  d: "M38.5,50.7c-0.1,0-0.2,0-0.3,0c-0.2,0-0.4-0.2-0.2-0.4c0.1-0.2,0.3-0.4,0.6-0.5c0.3-0.1,0.6-0.2,0.9-0.3 c0.1,0,0.3,0.1,0.4,0.2c0,0.1,0,0.3-0.1,0.4C39.4,50.5,39,50.7,38.5,50.7z"
}), React.createElement("path", {
  className: "st1",
  d: "M23,25.9c0-0.4,0.3-0.7,0.7-0.7c0.4,0,0.7,0.4,0.7,0.8c0,0.3-0.3,0.7-0.8,0.7C23.2,26.6,23,26.4,23,25.9z"
}), React.createElement("path", {
  className: "st1",
  d: "M20.4,38c-0.5,0-0.8-0.3-0.8-0.8c0-0.4,0.2-0.6,0.6-0.7c0.4,0,0.8,0.4,0.9,0.8C21.2,37.7,20.8,38,20.4,38z"
}), React.createElement("path", {
  className: "st1",
  d: "M55,29c-0.1,0.3-0.2,0.6-0.3,0.9c0,0.1-0.2,0.2-0.3,0.2c-0.1,0-0.3-0.1-0.3-0.3c-0.2-0.4-0.2-0.9-0.1-1.3 c0.1-0.3,0.1-0.6,0.5-0.6c0.2,0,0.4,0.4,0.4,0.7C54.9,28.8,54.9,28.9,55,29C54.9,29,55,29,55,29z"
}), React.createElement("path", {
  className: "st1",
  d: "M53.2,21.5c0,0.1,0,0.2,0,0.3c0,0.2-0.1,0.4-0.2,0.4c-0.1,0-0.3-0.1-0.4-0.2c-0.4-0.4-0.5-1-0.3-1.5 c0.1-0.3,0.4-0.3,0.6-0.1C53.1,20.7,53.2,21.1,53.2,21.5z"
}), React.createElement("path", {
  className: "st1",
  d: "M53.5,37c0,0.6-0.2,1-0.6,1.4c-0.1,0.1-0.3,0.1-0.4,0.2c0-0.1-0.1-0.2-0.1-0.4c0-0.6,0.2-1.2,0.7-1.6 c0.1-0.1,0.2-0.1,0.3-0.1c0.1,0.1,0.1,0.2,0.1,0.3C53.5,36.9,53.5,36.9,53.5,37z"
}), React.createElement("path", {
  className: "st1",
  d: "M20.4,39.3c0.4,0,0.8,0.4,0.8,0.8c0,0.3-0.4,0.6-0.7,0.5c-0.5-0.1-0.8-0.4-0.8-0.9 C19.7,39.4,19.9,39.3,20.4,39.3z"
}), React.createElement("path", {
  className: "st1",
  d: "M21.1,34.6c0,0.4-0.3,0.6-0.7,0.6c-0.4,0-0.7-0.3-0.7-0.8c0-0.4,0.3-0.7,0.6-0.7 C20.8,33.8,21.1,34.1,21.1,34.6z"
}), React.createElement("path", {
  className: "st1",
  d: "M50,17.1c-0.1,0.1-0.2,0.4-0.3,0.4c-0.1,0-0.4,0-0.5-0.1c-0.4-0.3-0.5-0.7-0.5-1.1c0-0.4,0.3-0.5,0.6-0.3 C49.6,16.2,49.9,16.7,50,17.1z"
}), React.createElement("path", {
  className: "st1",
  d: "M40.6,50.3c-0.1-0.1-0.3-0.1-0.4-0.2c0-0.1,0-0.3,0.1-0.4c0.4-0.5,0.9-0.7,1.5-0.7c0.3,0,0.4,0.1,0.3,0.4 C41.8,49.8,41.1,50.3,40.6,50.3z"
}), React.createElement("path", {
  className: "st1",
  d: "M55,31.4c0,0.4-0.1,0.8-0.3,1.1c-0.1,0.2-0.4,0.2-0.5,0c-0.1-0.3-0.1-0.7-0.1-1.1c0-0.2,0.1-0.5,0.3-0.7 c0.1-0.1,0.2-0.2,0.3-0.3c0.1,0.1,0.2,0.2,0.3,0.4C55.1,31.1,55,31.2,55,31.4z"
}), React.createElement("path", {
  className: "st1",
  d: "M52.3,19.1c-0.1,0.2-0.1,0.4-0.3,0.5c-0.3,0.1-0.5,0-0.6-0.3c-0.1-0.3-0.2-0.7-0.3-1c-0.1-0.2,0-0.4,0.2-0.5 c0.1,0,0.4,0.1,0.5,0.2C52,18.3,52.3,18.6,52.3,19.1z"
}), React.createElement("path", {
  className: "st1",
  d: "M21.2,31.7c0,0.4-0.3,0.7-0.6,0.7c-0.4,0-0.7-0.4-0.7-0.7c0-0.4,0.3-0.7,0.7-0.7 C20.9,30.9,21.2,31.2,21.2,31.7z"
}), React.createElement("path", {
  className: "st1",
  d: "M31.5,51.6c-0.2-0.1-0.4-0.1-0.6-0.2c-0.3-0.2-0.3-0.4,0-0.6c0.4-0.3,0.9-0.3,1.3-0.2c0.1,0,0.3,0.2,0.3,0.3 c0,0.1-0.1,0.3-0.2,0.4C32,51.4,31.7,51.5,31.5,51.6z"
}), React.createElement("path", {
  className: "st1",
  d: "M46.4,14c0.3,0,0.8,0.4,0.9,0.7c0.1,0.3,0.2,0.6-0.1,0.8c-0.3,0.1-0.6,0-0.8-0.3C46.2,15,46,14.7,46,14.4 C45.9,14.2,46.1,14,46.4,14z"
}), React.createElement("path", {
  className: "st1",
  d: "M31.3,16.7c0.4,0,0.8,0.3,0.7,0.7c0,0.3-0.3,0.6-0.7,0.6c-0.4,0-0.7-0.3-0.7-0.7 C30.6,16.9,30.8,16.7,31.3,16.7z"
}), React.createElement("path", {
  className: "st1",
  d: "M23.4,46.7c0.3,0,0.7,0.1,0.9,0.4c0.2,0.3,0.1,0.5-0.1,0.6c-0.3,0.2-1,0.1-1.2-0.2c-0.3-0.4-0.1-0.7,0.4-0.8 C23.3,46.7,23.4,46.7,23.4,46.7z"
}), React.createElement("path", {
  className: "st1",
  d: "M19.8,42.4c0-0.3,0.2-0.5,0.6-0.5c0.5,0,0.9,0.4,0.9,0.8c0,0.4-0.1,0.5-0.6,0.5 C20.1,43.1,19.7,42.7,19.8,42.4z"
}), React.createElement("path", {
  className: "st1",
  d: "M40.5,12.9c0.4,0,0.8,0.4,0.9,0.7c0.1,0.4-0.2,0.7-0.7,0.6c-0.4-0.1-0.6-0.3-0.7-0.6 C39.9,13.2,40.2,12.9,40.5,12.9z"
}), React.createElement("path", {
  className: "st1",
  d: "M42.7,49.7c-0.4,0-0.5-0.1-0.3-0.4c0.3-0.5,0.8-0.9,1.4-0.9c0.3,0,0.4,0.2,0.2,0.4 C43.7,49.3,43.3,49.6,42.7,49.7z"
}), React.createElement("path", {
  className: "st1",
  d: "M38.3,13.8c0-0.3,0.2-0.5,0.5-0.5c0.5,0,0.9,0.4,0.9,0.8c0,0.3-0.2,0.5-0.6,0.5 C38.7,14.5,38.3,14.2,38.3,13.8z"
}), React.createElement("path", {
  className: "st1",
  d: "M26.4,50c-0.3-0.1-0.5-0.2-0.7-0.4c-0.2-0.2-0.2-0.5,0.1-0.6c0.4-0.2,0.8-0.2,1.2,0.1 c0.1,0.1,0.2,0.3,0.2,0.4c0,0.1-0.2,0.2-0.4,0.3C26.7,49.9,26.6,49.9,26.4,50C26.4,49.9,26.4,49.9,26.4,50z"
}), React.createElement("path", {
  className: "st1",
  d: "M51,42.3c0,0.5-0.6,1.4-1.1,1.5c-0.2,0.1-0.4,0-0.3-0.2c0.2-0.7,0.4-1.2,1.1-1.6C50.9,41.9,51,42,51,42.3z"
}), React.createElement("path", {
  className: "st1",
  d: "M54,34.6c0.2-0.5,0.3-0.9,0.5-1.4c0-0.1,0.2-0.2,0.3-0.2c0.1,0,0.2,0.1,0.2,0.2c0,0.1,0.1,0.3,0.1,0.4 c-0.1,0.4-0.3,0.9-0.4,1.3c0,0.1-0.2,0.2-0.3,0.3c-0.1-0.1-0.1-0.3-0.2-0.4C54.1,34.8,54.1,34.7,54,34.6 C54.1,34.6,54,34.6,54,34.6z"
}), React.createElement("path", {
  className: "st1",
  d: "M37,13.5c0.4,0,0.8,0.4,0.8,0.7c0,0.3-0.3,0.6-0.6,0.6c-0.5,0-0.8-0.4-0.8-0.7C36.4,13.7,36.6,13.5,37,13.5z "
}), React.createElement("path", {
  className: "st1",
  d: "M47.1,46.3c0.1-0.1,0.2-0.4,0.3-0.6c0.2-0.4,0.6-0.6,1-0.8c0.2-0.1,0.4,0,0.3,0.3c-0.2,0.6-0.6,1.1-1.3,1.3 C47.2,46.6,47,46.7,47.1,46.3z"
}), React.createElement("path", {
  className: "st1",
  d: "M42.6,13.9c-0.4,0-0.8-0.3-0.9-0.7c0-0.2,0-0.3,0.1-0.5c0.1-0.2,0.3-0.2,0.5-0.1c0.4,0.1,0.7,0.4,0.7,0.8 C43,13.8,43,13.9,42.6,13.9z"
}), React.createElement("path", {
  className: "st1",
  d: "M53.1,39.2c-0.1,0.6-0.4,1.2-0.9,1.6c-0.1,0.1-0.2,0.1-0.3,0.1c-0.1,0-0.1-0.2-0.1-0.2 c0.1-0.6,0.3-1.2,0.8-1.6c0.1-0.1,0.2-0.1,0.4-0.1C53,39,53.1,39.1,53.1,39.2z"
}), React.createElement("path", {
  className: "st1",
  d: "M29,50.6c0.2,0.1,0.5,0.1,0.6,0.2c0.1,0.1,0.3,0.2,0.2,0.3c0,0.1-0.2,0.3-0.3,0.4c-0.3,0.1-0.7,0.3-1.1,0 c-0.1-0.1-0.3-0.2-0.3-0.4c0-0.1,0.2-0.3,0.3-0.4C28.7,50.6,28.9,50.6,29,50.6z"
}), React.createElement("path", {
  className: "st1",
  d: "M21.4,28.7c0,0.4-0.2,0.7-0.6,0.7c-0.4,0-0.7-0.3-0.7-0.7c0-0.4,0.3-0.7,0.6-0.6 C21.2,28,21.4,28.3,21.4,28.7z"
}), React.createElement("path", {
  className: "st1",
  d: "M26.6,19.6c0.4,0,0.6,0.2,0.6,0.6c0,0.5-0.3,0.7-0.6,0.7c-0.4,0-0.7-0.3-0.7-0.6 C25.9,19.8,26.2,19.6,26.6,19.6z"
}), React.createElement("path", {
  className: "st1",
  d: "M35.3,14.9c-0.5,0-0.8-0.3-0.8-0.7c0-0.3,0.3-0.5,0.6-0.5c0.4,0,0.8,0.3,0.8,0.7 C35.8,14.7,35.7,15,35.3,14.9z"
}), React.createElement("path", {
  className: "st1",
  d: "M49.8,15.7c0-0.1,0.1-0.3,0.2-0.3c0.1,0,0.4,0,0.5,0.2c0.3,0.3,0.5,0.6,0.5,1.1c0,0.1-0.1,0.3-0.1,0.4 c-0.1,0-0.3,0-0.4-0.1C50.1,16.6,49.9,16.2,49.8,15.7z"
}), React.createElement("path", {
  className: "st1",
  d: "M48.2,15c-0.6,0-1-0.9-0.9-1.3c0.1-0.2,0.2-0.3,0.4-0.2c0.4,0.1,0.8,0.7,0.8,1.1C48.6,14.9,48.5,15,48.2,15z "
}), React.createElement("path", {
  className: "st1",
  d: "M53.2,20c0.1-0.2,0.1-0.4,0.3-0.5c0.3-0.1,0.4,0.2,0.5,0.4c0.2,0.4,0.3,0.8,0.2,1.2 c-0.1,0.3-0.2,0.4-0.4,0.1C53.4,21,53.2,20.5,53.2,20z"
}), React.createElement("path", {
  className: "st1",
  d: "M54.2,22.8c0-0.2,0-0.3,0-0.4c0-0.1,0.1-0.3,0.2-0.3c0.1,0,0.3,0.1,0.3,0.1c0.3,0.5,0.5,1,0.2,1.6 c0,0.1-0.1,0.2-0.2,0.2c-0.1,0-0.2-0.1-0.3-0.1C54.2,23.5,54.1,23.2,54.2,22.8z"
}), React.createElement("path", {
  className: "st1",
  d: "M43.7,12.2c0.4,0,0.9,0.4,0.9,0.9c0,0.3-0.3,0.5-0.6,0.4c-0.3-0.1-0.5-0.3-0.7-0.6 C43.1,12.5,43.2,12.2,43.7,12.2z"
}), React.createElement("path", {
  className: "st1",
  d: "M55.6,25.8c0,0.2,0,0.4-0.1,0.6c0,0.1-0.1,0.2-0.2,0.2c-0.1,0-0.2-0.1-0.2-0.1c-0.3-0.6-0.3-1.2-0.1-1.8 c0.1-0.2,0.3-0.2,0.4,0C55.4,25,55.5,25.4,55.6,25.8C55.6,25.7,55.6,25.8,55.6,25.8z"
}), React.createElement("path", {
  className: "st1",
  d: "M23.9,23.6c-0.4,0-0.6-0.2-0.6-0.6c0-0.4,0.3-0.6,0.7-0.6c0.4,0,0.6,0.2,0.6,0.6 C24.5,23.4,24.3,23.6,23.9,23.6z"
}), React.createElement("path", {
  className: "st1",
  d: "M29.6,17.4c0,0.4-0.3,0.6-0.6,0.6c-0.4,0-0.7-0.3-0.7-0.6c0-0.4,0.3-0.6,0.6-0.6 C29.4,16.8,29.7,17,29.6,17.4z"
}), React.createElement("path", {
  className: "st1",
  d: "M21.3,45c0,0.2-0.1,0.3-0.3,0.4c-0.3,0.1-0.8,0-1-0.3c-0.1-0.1-0.1-0.4,0-0.5c0.1-0.1,0.3-0.2,0.4-0.3 C21,44.2,21.3,44.5,21.3,45z"
}), React.createElement("path", {
  className: "st1",
  d: "M55.6,29.3c-0.3-0.2-0.4-0.5-0.4-0.8c0-0.4,0.1-0.8,0.2-1.2c0-0.1,0.1-0.1,0.2-0.1c0.1,0,0.2,0.1,0.2,0.2 c0.2,0.6,0.2,1.2,0,1.7C55.8,29.1,55.7,29.2,55.6,29.3z"
}), React.createElement("path", {
  className: "st1",
  d: "M33.1,13.9c0.4,0,0.7,0.3,0.7,0.6c0,0.3-0.2,0.5-0.6,0.5c-0.4,0-0.7-0.3-0.7-0.6 C32.5,14.1,32.7,13.9,33.1,13.9z"
}), React.createElement("path", {
  className: "st1",
  d: "M46,47.7c0,0.5-0.4,0.8-0.7,1c-0.5,0.4-0.7,0.4-1,0.2C44.6,48.2,45.4,47.6,46,47.7z"
}), React.createElement("path", {
  className: "st1",
  d: "M53.2,18.5c0,0.1-0.1,0.2-0.1,0.3c-0.1-0.1-0.3-0.1-0.4-0.2c-0.3-0.3-0.5-0.7-0.5-1.2c0-0.1,0.1-0.3,0.1-0.3 c0.1,0,0.3,0,0.4,0.1C53,17.5,53.2,17.9,53.2,18.5z"
}), React.createElement("path", {
  className: "st1",
  d: "M44.6,12.1c0-0.4,0.2-0.5,0.6-0.4c0.4,0.1,0.6,0.5,0.7,0.8c0.1,0.2-0.1,0.4-0.4,0.4 C45,13,44.6,12.6,44.6,12.1z"
}), React.createElement("path", {
  className: "st1",
  d: "M35.7,52.5c-0.2-0.1-0.5-0.1-0.5-0.3c-0.1-0.2,0.2-0.3,0.4-0.5c0.4-0.2,0.7-0.3,1.1-0.2 c0.1,0,0.2,0.1,0.3,0.2c0,0.1,0,0.2-0.1,0.3C36.6,52.3,36.2,52.5,35.7,52.5z"
}), React.createElement("path", {
  className: "st1",
  d: "M53.9,37.6C53.7,37,54,36,54.6,35.5c0.2,0.3,0.1,0.6,0.1,0.9C54.6,37,54.2,37.5,53.9,37.6z"
}), React.createElement("path", {
  className: "st1",
  d: "M37.8,52.1c-0.1,0-0.2-0.1-0.4-0.2c0.1-0.1,0.2-0.3,0.3-0.4c0.4-0.3,0.8-0.4,1.3-0.4c0.1,0,0.3,0.1,0.3,0.2 c0,0.1,0,0.2-0.1,0.3C38.7,51.9,38.3,52.1,37.8,52.1z"
}), React.createElement("path", {
  className: "st1",
  d: "M21,25.1c0.3,0,0.6,0.3,0.6,0.6c0,0.4-0.3,0.6-0.6,0.6c-0.4,0-0.6-0.2-0.6-0.6C20.4,25.4,20.7,25.1,21,25.1z "
}), React.createElement("path", {
  className: "st1",
  d: "M33.6,52.7c-0.1,0-0.1,0-0.2,0c-0.2,0-0.5,0-0.5-0.2c0-0.1,0.2-0.4,0.4-0.4c0.4-0.1,0.8-0.2,1.2-0.1 c0.1,0,0.2,0.1,0.2,0.2c0,0.1-0.1,0.2-0.1,0.3C34.3,52.6,34,52.8,33.6,52.7z"
}), React.createElement("path", {
  className: "st1",
  d: "M48.5,13.4c0-0.4,0.1-0.5,0.5-0.4c0.5,0.2,0.6,0.6,0.7,1c0,0.1-0.1,0.3-0.2,0.3c0,0-0.2,0-0.3,0 C48.7,14.2,48.5,13.8,48.5,13.4z"
}), React.createElement("path", {
  className: "st1",
  d: "M55.9,29.5c0.1,0.2,0.2,0.4,0.2,0.6c0,0.5,0,1-0.3,1.4c0,0.1-0.1,0.1-0.2,0.1c0,0-0.2-0.1-0.2-0.1 c0-0.4-0.1-0.7,0-1.1C55.5,30.2,55.5,29.8,55.9,29.5z"
}), React.createElement("path", {
  className: "st1",
  d: "M39.8,51.7c-0.1,0-0.2-0.1-0.3-0.1c0.1-0.1,0.1-0.3,0.2-0.4c0.4-0.4,0.9-0.6,1.4-0.6c0.1,0,0.2,0,0.3,0.1 c0,0.1,0,0.2-0.1,0.3C40.9,51.4,40.4,51.6,39.8,51.7z"
}), React.createElement("path", {
  className: "st1",
  d: "M26.6,51.5c-0.3-0.1-0.5-0.2-0.7-0.3c-0.2-0.2-0.2-0.4,0.1-0.5c0.4-0.2,0.7-0.2,1.1,0 c0.1,0.1,0.2,0.2,0.4,0.4c-0.1,0.1-0.2,0.2-0.4,0.3C26.9,51.5,26.7,51.5,26.6,51.5C26.6,51.5,26.6,51.5,26.6,51.5z"
}), React.createElement("path", {
  className: "st1",
  d: "M23.7,48.6c0.2,0.1,0.5,0.2,0.7,0.4c0.2,0.2,0.1,0.4-0.1,0.6c-0.3,0.2-1,0-1.2-0.3c-0.2-0.2-0.1-0.5,0.2-0.6 C23.4,48.7,23.6,48.7,23.7,48.6C23.7,48.7,23.7,48.7,23.7,48.6z"
}), React.createElement("path", {
  className: "st1",
  d: "M52,16.1c0,0.1-0.1,0.2-0.2,0.3c-0.1,0-0.2,0-0.3-0.1c-0.4-0.3-0.7-0.7-0.7-1.3c0-0.3,0.2-0.4,0.4-0.2 C51.7,15,51.9,15.5,52,16.1z"
}), React.createElement("path", {
  className: "st1",
  d: "M18.3,34.2c0,0.3-0.2,0.5-0.5,0.5c-0.4,0-0.7-0.3-0.6-0.7c0-0.3,0.3-0.6,0.5-0.6 C18,33.5,18.3,33.9,18.3,34.2z"
}), React.createElement("path", {
  className: "st1",
  d: "M50.2,44.1c0.2,0.6-0.8,1.7-1.4,1.7C48.7,45.2,49.5,44.3,50.2,44.1z"
}), React.createElement("path", {
  className: "st1",
  d: "M51.2,43c-0.1-0.7,0.6-1.8,1.2-1.9C52.6,41.7,51.9,42.8,51.2,43z"
}), React.createElement("path", {
  className: "st1",
  d: "M17,39.5c0-0.3,0.1-0.4,0.5-0.5c0.5,0,0.7,0.4,0.7,0.7c0,0.2-0.2,0.5-0.5,0.5C17.4,40.1,17.1,39.9,17,39.5z"
}), React.createElement("path", {
  className: "st1",
  d: "M31.5,52c0.2,0.1,0.4,0.1,0.6,0.2c0.1,0,0.2,0.1,0.2,0.2c0,0.1-0.1,0.3-0.1,0.3c-0.4,0.1-0.9,0.4-1.3,0.1 c-0.1-0.1-0.2-0.1-0.2-0.2c0-0.1,0.1-0.2,0.1-0.2C31,52.2,31.3,52.1,31.5,52z"
}), React.createElement("path", {
  className: "st1",
  d: "M17.7,37.5c-0.4,0-0.7-0.2-0.7-0.7c0-0.4,0.1-0.5,0.5-0.5c0.4,0,0.7,0.3,0.7,0.7 C18.2,37.3,18,37.5,17.7,37.5z"
}), React.createElement("path", {
  className: "st1",
  d: "M39.7,11.7c-0.3,0-0.7-0.3-0.8-0.6c-0.1-0.2,0.2-0.5,0.5-0.5c0.3,0,0.8,0.4,0.8,0.6 C40.3,11.5,40,11.7,39.7,11.7z"
}), React.createElement("path", {
  className: "st1",
  d: "M45.8,11.6c0-0.3,0.3-0.5,0.6-0.3c0.2,0.2,0.4,0.4,0.6,0.6c0.1,0.1,0.1,0.4,0,0.5c-0.1,0.1-0.3,0.1-0.4,0.1 C46.2,12.4,45.8,12,45.8,11.6z"
}), React.createElement("path", {
  className: "st1",
  d: "M31.7,14.6c0,0.3-0.2,0.5-0.6,0.5c-0.4,0-0.6-0.3-0.6-0.6c0-0.3,0.2-0.5,0.6-0.5 C31.4,14.1,31.7,14.3,31.7,14.6z"
}), React.createElement("path", {
  className: "st1",
  d: "M20.2,46.8c-0.1-0.3,0.2-0.3,0.4-0.4c0.3-0.1,0.8,0.2,0.9,0.5c0.1,0.3,0.1,0.5-0.3,0.6 C20.7,47.6,20.2,47.2,20.2,46.8z"
}), React.createElement("path", {
  className: "st1",
  d: "M23.6,20.1c0-0.4,0.2-0.6,0.6-0.6c0.3,0,0.6,0.3,0.6,0.6c0,0.3-0.3,0.6-0.6,0.6 C23.8,20.6,23.6,20.4,23.6,20.1z"
}), React.createElement("path", {
  className: "st1",
  d: "M55.3,21.1c0.1,0.3,0.3,0.5,0.4,0.7c0.1,0.4,0.3,0.8,0.1,1.2c-0.1,0.1-0.1,0.3-0.3,0.1 C55.1,22.7,54.9,21.6,55.3,21.1z"
}), React.createElement("path", {
  className: "st1",
  d: "M18.4,31.3c0,0.4-0.2,0.6-0.5,0.6c-0.2,0-0.6-0.4-0.6-0.7c0-0.3,0.2-0.6,0.5-0.6 C18.2,30.7,18.4,30.9,18.4,31.3z"
}), React.createElement("path", {
  className: "st1",
  d: "M38.6,11.5c0,0.3-0.2,0.4-0.5,0.4c-0.5,0-0.8-0.4-0.7-0.7c0-0.3,0.2-0.4,0.5-0.4 C38.3,10.9,38.6,11.1,38.6,11.5z"
}), React.createElement("path", {
  className: "st1",
  d: "M26.7,16.8c0.4,0,0.6,0.2,0.6,0.5c0,0.3-0.3,0.6-0.6,0.6c-0.3,0-0.6-0.3-0.6-0.6 C26.1,17,26.4,16.8,26.7,16.8z"
}), React.createElement("path", {
  className: "st1",
  d: "M36.4,12.1c-0.4,0-0.8-0.3-0.7-0.6c0-0.3,0.2-0.4,0.6-0.4c0.4,0,0.7,0.3,0.7,0.6 C36.9,12,36.7,12.1,36.4,12.1z"
}), React.createElement("path", {
  className: "st1",
  d: "M41.7,11c0,0.2-0.1,0.3-0.3,0.3c-0.3,0.1-0.8-0.2-0.9-0.5c-0.1-0.3,0.1-0.6,0.4-0.6 C41.4,10.3,41.7,10.6,41.7,11z"
}), React.createElement("path", {
  className: "st1",
  d: "M55.4,34.2c-0.2-0.7,0-1.4,0.3-2c0-0.1,0.1-0.1,0.2-0.1c0,0,0.1,0.1,0.1,0.1c0,0.7,0,1.4-0.4,1.9 C55.5,34.2,55.5,34.2,55.4,34.2C55.5,34.3,55.4,34.2,55.4,34.2z"
}), React.createElement("path", {
  className: "st1",
  d: "M56,23.6c0.1,0.1,0.2,0.3,0.3,0.4c0.1,0.5,0.2,1,0.1,1.5c0,0.1-0.1,0.1-0.1,0.2c-0.1,0-0.1-0.1-0.2-0.1 c-0.3-0.6-0.4-1.3-0.1-1.9C55.9,23.7,55.9,23.7,56,23.6z"
}), React.createElement("path", {
  className: "st1",
  d: "M17.9,42.6c-0.4,0-0.7-0.3-0.7-0.7c0-0.3,0.2-0.4,0.4-0.4c0.3,0,0.8,0.4,0.8,0.7 C18.4,42.5,18.2,42.6,17.9,42.6z"
}), React.createElement("path", {
  className: "st1",
  d: "M54.8,20.7c-0.6-0.5-0.7-1.2-0.7-1.9c0.1,0,0.3,0,0.3,0.1C54.9,19.2,55,20.2,54.8,20.7z"
}), React.createElement("path", {
  className: "st1",
  d: "M54.2,37.9c0.1,0.8-0.3,1.7-0.9,2C53.1,39.4,53.7,38,54.2,37.9z"
}), React.createElement("path", {
  className: "st1",
  d: "M46.2,48.3c0.1-0.7,1-1.5,1.6-1.4C47.6,47.6,46.8,48.3,46.2,48.3z"
}), React.createElement("path", {
  className: "st1",
  d: "M41.6,51.1c0.1-0.6,1.1-1.2,1.7-1C43.2,50.6,42.3,51.2,41.6,51.1z"
}), React.createElement("path", {
  className: "st1",
  d: "M53.1,16.3c0.2,0.2,0.3,0.3,0.5,0.5c0.2,0.3,0.4,0.7,0.4,1.1c0,0.1,0,0.2-0.1,0.2c-0.1,0-0.2,0-0.2-0.1 C53.1,17.6,52.9,16.9,53.1,16.3z"
}), React.createElement("path", {
  className: "st1",
  d: "M50.2,13.9c-0.3-0.1-0.6-0.4-0.7-0.8c-0.1-0.2-0.1-0.5,0-0.6c0.2-0.2,0.4,0,0.6,0.2c0.2,0.3,0.3,0.5,0.5,0.8 C50.6,13.7,50.5,13.9,50.2,13.9z"
}), React.createElement("path", {
  className: "st1",
  d: "M42.7,11c-0.4-0.1-0.8-0.3-0.9-0.7c-0.1-0.3,0.1-0.5,0.4-0.5c0.3,0,0.7,0.4,0.8,0.7C43.1,10.9,43,11,42.7,11 z"
}), React.createElement("path", {
  className: "st1",
  d: "M20.9,22.8c0-0.4,0.2-0.5,0.6-0.5c0.3,0,0.5,0.2,0.5,0.5c0,0.3-0.3,0.6-0.6,0.6C21,23.3,20.9,23.2,20.9,22.8 z"
}), React.createElement("path", {
  className: "st1",
  d: "M34.5,11.3c0.4,0,0.7,0.3,0.7,0.6c0,0.2-0.2,0.4-0.5,0.4c-0.4,0-0.7-0.3-0.7-0.6 C33.9,11.5,34.2,11.3,34.5,11.3z"
}), React.createElement("path", {
  className: "st1",
  d: "M47.1,10.8c0.5,0,1.1,0.7,1,1.1c0,0.1-0.2,0.2-0.3,0.2c-0.4-0.1-1-0.6-0.8-1.1C46.9,10.9,47,10.8,47.1,10.8z "
}), React.createElement("path", {
  className: "st1",
  d: "M43.4,9.6c0.4,0,0.8,0.4,0.9,0.7c0,0.2-0.1,0.4-0.3,0.4c-0.3,0-0.8-0.4-0.9-0.7C43,9.7,43.2,9.6,43.4,9.6z"
}), React.createElement("path", {
  className: "st1",
  d: "M56.4,28.3c-0.4-0.6-0.4-1.8,0-2.1C56.8,26.7,56.8,27.9,56.4,28.3z"
}), React.createElement("path", {
  className: "st1",
  d: "M29,52.9c-0.2-0.1-0.4-0.1-0.6-0.2c-0.1,0-0.1-0.1-0.1-0.2c0-0.1,0.1-0.2,0.1-0.2c0.4-0.2,0.9-0.2,1.3,0 c0.1,0,0.2,0.1,0.2,0.2c0,0.1-0.1,0.2-0.1,0.2C29.5,52.8,29.3,52.9,29,52.9z"
}), React.createElement("path", {
  className: "st1",
  d: "M18.1,27.8c0.3,0,0.5,0.2,0.5,0.5c0,0.3-0.2,0.6-0.5,0.6c-0.3,0-0.5-0.2-0.5-0.6 C17.6,28,17.8,27.8,18.1,27.8z"
}), React.createElement("path", {
  className: "st1",
  d: "M52.6,15.6c-0.5-0.1-0.9-1-0.9-1.4c0-0.2,0.1-0.3,0.3-0.1c0.4,0.3,0.6,0.8,0.7,1.3 C52.7,15.4,52.7,15.5,52.6,15.6z"
}), React.createElement("path", {
  className: "st1",
  d: "M23.8,50.4c0.3,0.1,0.6,0.2,0.8,0.4c0.2,0.1,0.1,0.4-0.1,0.4c-0.4,0.1-0.8,0.1-1.1-0.2 c-0.1-0.1-0.2-0.3-0.1-0.3C23.4,50.6,23.6,50.5,23.8,50.4z"
}), React.createElement("path", {
  className: "st1",
  d: "M18.2,44.9c-0.4,0-0.7-0.3-0.7-0.6c0-0.3,0.2-0.3,0.4-0.3c0.4,0,0.8,0.3,0.8,0.7 C18.6,44.9,18.4,44.9,18.2,44.9z"
}), React.createElement("path", {
  className: "st1",
  d: "M21,48.4c0.2,0.1,0.5,0.2,0.7,0.3c0.1,0.1,0.2,0.3,0.1,0.4c0,0.1-0.2,0.2-0.4,0.2c-0.3-0.1-0.5-0.2-0.8-0.3 c-0.1-0.1-0.1-0.3-0.1-0.4C20.6,48.5,20.8,48.5,21,48.4z"
}), React.createElement("path", {
  className: "st1",
  d: "M43.5,50.5c0.1-0.5,0.4-0.6,0.6-0.8c0.2-0.2,0.5-0.3,0.8-0.4c0.1,0,0.1,0,0.2,0c0,0.1,0,0.2,0,0.2 c-0.3,0.5-0.8,0.8-1.4,0.9C43.6,50.5,43.6,50.5,43.5,50.5z"
}), React.createElement("path", {
  className: "st1",
  d: "M45.1,10.2c-0.3,0-0.9-0.4-0.9-0.7c0-0.2,0-0.3,0.2-0.3c0.4-0.1,1,0.4,1,0.8C45.4,10.2,45.3,10.2,45.1,10.2z "
}), React.createElement("path", {
  className: "st1",
  d: "M56.5,30.8c-0.3-0.4-0.2-1.7,0.1-2.1C57,29,56.9,30.2,56.5,30.8z"
}), React.createElement("path", {
  className: "st1",
  d: "M51.6,43.1c0,0.7-0.8,1.7-1.3,1.7C50.6,44.1,50.9,43.5,51.6,43.1z"
}), React.createElement("path", {
  className: "st1",
  d: "M55.1,36.6c-0.2-0.6,0.2-1.9,0.6-2.1C55.8,35.3,55.6,36,55.1,36.6z"
}), React.createElement("path", {
  className: "st1",
  d: "M47.8,10.4c0.5,0,1.1,0.5,1.1,1c0,0.2-0.1,0.3-0.3,0.2C48.2,11.4,47.8,10.9,47.8,10.4z"
}), React.createElement("path", {
  className: "st1",
  d: "M18.1,25.4c0-0.3,0.2-0.6,0.5-0.6c0.2,0,0.5,0.3,0.5,0.5c0,0.2-0.3,0.5-0.5,0.5 C18.2,25.9,18.1,25.8,18.1,25.4z"
}), React.createElement("path", {
  className: "st1",
  d: "M47.9,47.5c0.1-0.7,0.9-1.4,1.4-1.5C49.3,46.5,48.4,47.4,47.9,47.5z"
}), React.createElement("path", {
  className: "st1",
  d: "M36.8,53.2c0.2-0.5,1.3-0.9,1.7-0.6C38.3,53,37.3,53.4,36.8,53.2z"
}), React.createElement("path", {
  className: "st1",
  d: "M34.7,53.4c0.1-0.1,0.2-0.2,0.3-0.3c0.4-0.2,0.8-0.3,1.2-0.2c0.1,0,0.2,0.1,0.2,0.1c0,0.1,0,0.2-0.1,0.2 c-0.2,0.1-0.4,0.3-0.7,0.3c-0.3,0.1-0.6,0-0.9,0.1C34.8,53.5,34.7,53.5,34.7,53.4z"
}), React.createElement("path", {
  className: "st1",
  d: "M26.6,52.1c0.2,0.1,0.4,0.1,0.7,0.2c0.1,0,0.2,0.2,0.1,0.2c0,0.1-0.1,0.2-0.2,0.2c-0.3,0-0.6,0-1,0 c-0.1,0-0.2-0.2-0.3-0.3c0.1-0.1,0.2-0.2,0.3-0.2C26.3,52.1,26.4,52.1,26.6,52.1z"
}), React.createElement("path", {
  className: "st1",
  d: "M29,14.2c0.4,0,0.5,0.1,0.5,0.4c0,0.3-0.2,0.5-0.5,0.5c-0.3,0-0.6-0.2-0.6-0.4C28.4,14.4,28.7,14.2,29,14.2z "
}), React.createElement("path", {
  className: "st1",
  d: "M21.3,19.9c0-0.3,0.2-0.5,0.5-0.5c0.3,0,0.5,0.2,0.5,0.4c0,0.3-0.3,0.5-0.6,0.6 C21.5,20.4,21.3,20.2,21.3,19.9z"
}), React.createElement("path", {
  className: "st1",
  d: "M51.2,13.3c-0.5-0.1-1-0.8-1-1.2c0-0.2,0.1-0.3,0.3-0.2C50.9,12.1,51.2,12.8,51.2,13.3z"
}), React.createElement("path", {
  className: "st1",
  d: "M33.7,53.2c0.1,0,0.2,0,0.3,0c0.1,0,0.2,0.1,0.3,0.1c-0.1,0.1-0.1,0.2-0.2,0.3c-0.4,0.2-0.8,0.2-1.3,0.2 c-0.1,0-0.1-0.1-0.2-0.1c0,0,0.1-0.1,0.1-0.2C33,53.3,33.3,53.2,33.7,53.2C33.7,53.1,33.7,53.2,33.7,53.2z"
}), React.createElement("path", {
  className: "st1",
  d: "M52.6,41.9c0.3-1,0.6-1.5,1-1.8C53.7,40.7,53,42,52.6,41.9z"
}), React.createElement("path", {
  className: "st1",
  d: "M18.5,47c-0.3,0-0.7-0.3-0.7-0.6c0-0.1,0.1-0.2,0.1-0.3c0.2-0.2,0.9,0.1,0.9,0.4C18.9,46.9,18.8,47,18.5,47z "
}), React.createElement("path", {
  className: "st1",
  d: "M32.8,12.4c-0.3,0-0.6-0.2-0.6-0.5c0-0.2,0.2-0.4,0.5-0.4c0.3,0,0.6,0.3,0.6,0.5 C33.3,12.2,33,12.4,32.8,12.4z"
}), React.createElement("path", {
  className: "st1",
  d: "M38.8,52.8c0.1-0.5,1-0.8,1.6-0.8C40.4,52.5,39.5,52.9,38.8,52.8z"
}), React.createElement("path", {
  className: "st1",
  d: "M46.3,9.7c-0.1,0-0.2,0.1-0.3,0.1c-0.4-0.1-0.6-0.3-0.8-0.6c-0.1-0.1,0-0.3,0-0.4c0,0,0.2,0,0.3,0 C46,8.9,46.3,9.3,46.3,9.7z"
}), React.createElement("path", {
  className: "st1",
  d: "M32.1,53.6c-0.4,0.5-1.2,0.5-1.7,0.2C30.7,53.3,31.6,53.2,32.1,53.6z"
}), React.createElement("path", {
  className: "st1",
  d: "M53.7,15.6c0.5,0.3,0.9,1.2,0.8,1.7c-0.3,0-0.4-0.3-0.5-0.5C53.8,16.5,53.6,16.1,53.7,15.6z"
}), React.createElement("path", {
  className: "st1",
  d: "M54.9,17.9c0.5,0.6,0.7,1.2,0.6,1.9C55,19.5,54.7,18.5,54.9,17.9z"
}), React.createElement("path", {
  className: "st1",
  d: "M56.2,22.3c-0.5-0.6-0.7-1.6-0.4-1.9C56.2,20.7,56.5,21.9,56.2,22.3z"
}), React.createElement("path", {
  className: "st1",
  d: "M39.8,9.1c-0.2-0.1-0.4-0.2-0.6-0.4c-0.1-0.1-0.1-0.4-0.1-0.4c0.1-0.1,0.3-0.1,0.5-0.1 c0.1,0,0.3,0.1,0.4,0.3c0.1,0.1,0.2,0.3,0.1,0.4C40.2,8.9,40,9,39.8,9.1z"
}), React.createElement("path", {
  className: "st1",
  d: "M38.5,9.3c-0.4,0-0.6-0.2-0.7-0.5c0-0.3,0.2-0.3,0.4-0.3c0.3,0,0.7,0.3,0.7,0.6C38.9,9.2,38.8,9.3,38.5,9.3z "
}), React.createElement("path", {
  className: "st1",
  d: "M56.8,31.1c0.2,0.8-0.1,1.5-0.3,2.2C56.1,32.8,56.3,31.5,56.8,31.1z"
}), React.createElement("path", {
  className: "st1",
  d: "M24.5,16.8c0.3,0,0.5,0.1,0.5,0.4c0,0.3-0.2,0.5-0.5,0.5c-0.3,0-0.4-0.2-0.4-0.4C24,17,24.2,16.8,24.5,16.8z "
}), React.createElement("path", {
  className: "st1",
  d: "M41.3,8.7c-0.5,0-0.9-0.3-0.9-0.6c0-0.2,0.1-0.3,0.3-0.3c0.3,0,0.9,0.4,0.8,0.6C41.5,8.6,41.3,8.7,41.3,8.7z "
}), React.createElement("path", {
  className: "st1",
  d: "M36.8,8.7c0.4,0,0.7,0.3,0.7,0.5c0,0.2-0.2,0.3-0.4,0.3c-0.3,0-0.6-0.3-0.6-0.5C36.4,8.7,36.6,8.7,36.8,8.7z "
}), React.createElement("path", {
  className: "st1",
  d: "M46.8,48.5c-0.4,0.7-0.9,1-1.6,1.3C45.3,49.3,46.2,48.6,46.8,48.5z"
}), React.createElement("path", {
  className: "st1",
  d: "M52.3,13.4c0.5,0.1,1.1,1.1,0.8,1.5C52.7,14.7,52.3,13.9,52.3,13.4z"
}), React.createElement("path", {
  className: "st1",
  d: "M14.9,35.9c0.3,0,0.6,0.3,0.6,0.6c0,0.2-0.2,0.4-0.4,0.4c-0.3,0-0.5-0.3-0.5-0.6 C14.6,36.1,14.7,36,14.9,35.9z"
}), React.createElement("path", {
  className: "st1",
  d: "M56.5,22.8c0.4,0.6,0.6,1.6,0.3,2.1C56.4,24.2,56.3,23.5,56.5,22.8z"
}), React.createElement("path", {
  className: "st1",
  d: "M40.7,52.2c0.4-0.5,0.9-0.7,1.5-0.9c0.1,0,0.1,0,0.2,0c0,0.1,0,0.1,0,0.2c-0.2,0.2-0.4,0.3-0.6,0.4 c-0.3,0.2-0.7,0.2-1,0.4C40.7,52.3,40.7,52.3,40.7,52.2z"
}), React.createElement("path", {
  className: "st1",
  d: "M15.2,39.5c-0.4,0-0.6-0.2-0.6-0.6c0-0.2,0.1-0.3,0.3-0.4c0.3,0,0.6,0.3,0.6,0.6 C15.5,39.3,15.5,39.6,15.2,39.5z"
}), React.createElement("path", {
  className: "st1",
  d: "M49.5,11c-0.5-0.1-1-0.6-1-1.1C49.1,9.8,49.6,10.4,49.5,11z"
}), React.createElement("path", {
  className: "st1",
  d: "M42.3,8.4c-0.3,0-0.7-0.2-0.8-0.5c-0.1-0.2,0-0.4,0.2-0.4c0.3,0,0.6,0.2,0.8,0.5C42.6,8.2,42.5,8.4,42.3,8.4 z"
}), React.createElement("path", {
  className: "st1",
  d: "M55.3,36.9c0,0.8-0.3,1.4-0.8,2C54.4,38.3,54.8,37.2,55.3,36.9z"
}), React.createElement("path", {
  className: "st1",
  d: "M19,22c0.3,0,0.4,0.1,0.4,0.4c0,0.2-0.2,0.5-0.5,0.5c-0.3,0-0.4-0.1-0.4-0.4C18.5,22.2,18.7,22,19,22z"
}), React.createElement("path", {
  className: "st1",
  d: "M21.4,50.2c0.2,0.1,0.5,0.2,0.7,0.3c0.2,0.2,0.1,0.3-0.1,0.4c-0.2,0.1-0.8-0.1-0.9-0.3 c-0.1-0.1-0.1-0.3-0.1-0.3C21.1,50.3,21.2,50.3,21.4,50.2z"
}), React.createElement("path", {
  className: "st1",
  d: "M47.1,9.2c0,0.1-0.1,0.2-0.3,0.1c-0.3-0.1-0.6-0.4-0.7-0.7c0-0.1,0-0.2,0-0.3c0,0,0.1,0,0.2,0 C46.7,8.5,47.1,8.8,47.1,9.2z"
}), React.createElement("path", {
  className: "st1",
  d: "M50.8,11.3c0.5,0.1,1,0.9,1,1.3C51.3,12.6,50.8,11.9,50.8,11.3z"
}), React.createElement("path", {
  className: "st1",
  d: "M15.5,33.7c0,0.2-0.2,0.4-0.4,0.4c-0.2,0-0.4-0.3-0.4-0.5c0-0.2,0.1-0.4,0.4-0.4 C15.2,33.2,15.5,33.5,15.5,33.7z"
}), React.createElement("path", {
  className: "st1",
  d: "M15.6,41.8c-0.1,0-0.2,0.2-0.3,0.2c-0.3,0-0.6-0.2-0.6-0.5c0-0.2,0.1-0.3,0.3-0.3 C15.3,41.1,15.6,41.4,15.6,41.8z"
}), React.createElement("path", {
  className: "st1",
  d: "M43.4,8.1c-0.4-0.1-0.7-0.2-0.9-0.6c-0.1-0.2,0-0.3,0.2-0.3c0.3,0,0.8,0.3,0.9,0.6C43.6,7.9,43.4,8,43.4,8.1 z"
}), React.createElement("path", {
  className: "st1",
  d: "M18.8,48.9c-0.2-0.1-0.5-0.3-0.6-0.4c-0.2-0.2-0.1-0.4,0.2-0.3c0.2,0,0.5,0.1,0.7,0.2c0.1,0,0.1,0.2,0.1,0.4 C19.2,48.8,19,48.8,18.8,48.9z"
}), React.createElement("path", {
  className: "st1",
  d: "M35.6,9.6c-0.4,0-0.7-0.2-0.6-0.4c0-0.1,0.2-0.3,0.3-0.3c0.3-0.1,0.6,0.2,0.6,0.5 C35.9,9.6,35.7,9.6,35.6,9.6z"
}), React.createElement("path", {
  className: "st1",
  d: "M30.8,11.6c0.3,0,0.5,0.2,0.5,0.4c0,0.2-0.2,0.4-0.4,0.4c-0.2,0-0.4-0.1-0.5-0.4 C30.4,11.8,30.6,11.6,30.8,11.6z"
}), React.createElement("path", {
  className: "st1",
  d: "M27.3,14.6c0,0.3-0.2,0.4-0.4,0.4c-0.2,0-0.5-0.2-0.5-0.4c0-0.2,0.3-0.5,0.5-0.4 C27.1,14.2,27.4,14.3,27.3,14.6z"
}), React.createElement("path", {
  className: "st1",
  d: "M28.3,53.7c0.3-0.3,1.1-0.3,1.4,0C29.4,54.1,28.6,54.1,28.3,53.7z"
}), React.createElement("path", {
  className: "st1",
  d: "M43.4,6.9c0.5-0.2,0.9,0.2,1,0.6c0,0-0.1,0.2-0.2,0.2C43.8,7.7,43.4,7.3,43.4,6.9z"
}), React.createElement("path", {
  className: "st1",
  d: "M51.7,43.9c0.2-0.7,0.6-1.3,1.2-1.7C52.6,42.8,52.3,43.5,51.7,43.9z"
}), React.createElement("path", {
  className: "st1",
  d: "M42.5,51.7c0.3-0.5,1.1-1,1.7-1C43.7,51.3,43.2,51.6,42.5,51.7z"
}), React.createElement("path", {
  className: "st1",
  d: "M57.1,27.3c-0.3-0.6-0.3-1.7-0.1-2.1C57.2,25.9,57.3,26.6,57.1,27.3z"
}), React.createElement("path", {
  className: "st1",
  d: "M47.7,8.8c-0.5,0-1-0.5-0.9-1C47.3,8,47.7,8.4,47.7,8.8z"
}), React.createElement("path", {
  className: "st1",
  d: "M15.9,44C15.9,44.1,15.9,44.1,15.9,44c0,0.3-0.2,0.3-0.3,0.3c-0.3,0-0.6-0.4-0.5-0.6 c0.1-0.2,0.2-0.2,0.4-0.2C15.6,43.6,15.8,43.8,15.9,44z"
}), React.createElement("path", {
  className: "st1",
  d: "M50.1,10.4c0,0-0.1,0.1-0.2,0c-0.4-0.2-0.7-0.6-0.9-1c0,0,0.1-0.2,0.1-0.2C49.4,9.3,50.1,10.1,50.1,10.4z"
}), React.createElement("path", {
  className: "st1",
  d: "M50.6,45.1c-0.2,0.7-0.7,1.1-1.2,1.5C49.6,45.9,50.1,45.5,50.6,45.1z"
}), React.createElement("path", {
  className: "st1",
  d: "M15.6,30.8c0,0.3,0,0.4-0.3,0.4c-0.2,0-0.4-0.2-0.4-0.5c0-0.2,0.1-0.4,0.3-0.4 C15.5,30.4,15.7,30.6,15.6,30.8z"
}), React.createElement("path", {
  className: "st1",
  d: "M48.3,47.7c-0.4,0.5-0.8,1-1.4,1.3C46.9,48.6,47.7,47.9,48.3,47.7z"
}), React.createElement("path", {
  className: "st1",
  d: "M23.6,52.2c0.3-0.2,0.9-0.2,1.1,0.1c0,0.1,0,0.2,0,0.3C24.5,52.7,23.8,52.5,23.6,52.2z"
}), React.createElement("path", {
  className: "st1",
  d: "M56,35.5c0.1-0.7,0.1-1.4,0.5-2C56.5,34.1,56.4,35,56,35.5z"
}), React.createElement("path", {
  className: "st1",
  d: "M53.5,14.2c-0.4-0.4-0.8-0.8-0.8-1.5C53.2,13.2,53.5,13.6,53.5,14.2z"
}), React.createElement("path", {
  className: "st1",
  d: "M54.8,16.5c-0.5-0.4-0.6-1-0.8-1.6C54.4,15.1,54.7,15.8,54.8,16.5z"
}), React.createElement("path", {
  className: "st1",
  d: "M16,46.5c-0.2-0.2-0.4-0.3-0.6-0.5c0,0,0-0.2,0.1-0.2c0.1-0.1,0.2-0.1,0.2-0.1c0.2,0.1,0.4,0.2,0.5,0.4 C16.4,46.3,16.3,46.4,16,46.5z"
}), React.createElement("path", {
  className: "st1",
  d: "M45.1,7.2c-0.5,0-1-0.3-1-0.7C44.6,6.5,45,6.7,45.1,7.2z"
}), React.createElement("path", {
  className: "st1",
  d: "M33.8,9.1c0.3,0,0.7,0.2,0.6,0.4c-0.1,0.1-0.3,0.2-0.4,0.3c-0.3,0-0.5-0.1-0.5-0.4 C33.5,9.1,33.6,9.1,33.8,9.1z"
}), React.createElement("path", {
  className: "st1",
  d: "M39.7,6.7c-0.3-0.1-0.5-0.1-0.7-0.3c-0.1,0-0.1-0.3-0.1-0.4c0.1,0,0.3,0,0.4,0C39.5,6.1,39.8,6.2,39.7,6.7z"
}), React.createElement("path", {
  className: "st1",
  d: "M35.9,54c-0.5,0.4-1,0.4-1.6,0.4C34.5,54.1,35.2,53.9,35.9,54z"
}), React.createElement("path", {
  className: "st1",
  d: "M55.9,19c-0.4-0.6-0.6-1.1-0.7-1.8C55.5,17.4,55.9,18.3,55.9,19z"
}), React.createElement("path", {
  className: "st1",
  d: "M54.6,39.1c-0.1,0.7-0.4,1.2-0.8,1.7C53.8,40.2,54.2,39.7,54.6,39.1z"
}), React.createElement("path", {
  className: "st1",
  d: "M37.8,53.6c-0.4,0.4-1,0.5-1.5,0.5C36.7,53.7,37.2,53.6,37.8,53.6z"
}), React.createElement("path", {
  className: "st1",
  d: "M51.1,10.7c0.5,0.2,1,0.9,0.9,1.3C51.6,11.7,51.3,11.3,51.1,10.7z"
}), React.createElement("path", {
  className: "st1",
  d: "M48.2,8.3c-0.4,0-0.9-0.4-1-0.9C47.6,7.4,48.1,7.9,48.2,8.3z"
}), React.createElement("path", {
  className: "st1",
  d: "M57.2,29.7c-0.1-0.7-0.2-1.3,0-2c0,0,0.1,0,0.1,0c0,0.2,0,0.4,0,0.6c0,0.2,0,0.4,0,0.7 C57.3,29.3,57.2,29.5,57.2,29.7z"
}), React.createElement("path", {
  className: "st1",
  d: "M15.3,27.9c-0.1-0.2,0.1-0.4,0.3-0.4c0.2,0,0.3,0.2,0.3,0.4c0,0.3-0.1,0.3-0.4,0.3 C15.4,28.3,15.3,28.1,15.3,27.9z"
}), React.createElement("path", {
  className: "st1",
  d: "M39.8,5.7c0.6,0,0.9,0.2,0.9,0.6C40.2,6.5,39.8,6.2,39.8,5.7z"
}), React.createElement("path", {
  className: "st1",
  d: "M38.1,53.7c0.4-0.4,1-0.6,1.5-0.6C39.2,53.5,38.7,53.7,38.1,53.7z"
}), React.createElement("path", {
  className: "st1",
  d: "M38.5,6.9c-0.4,0-0.7-0.3-0.7-0.5c0-0.1,0.2-0.2,0.3-0.2c0.3,0,0.6,0.2,0.6,0.4C38.6,6.8,38.5,6.9,38.5,6.9z "
}), React.createElement("path", {
  className: "st1",
  d: "M29,12.5c-0.2-0.2-0.4-0.3-0.4-0.5c0-0.2,0.2-0.3,0.4-0.3c0.2,0,0.4,0.1,0.3,0.3 C29.3,12.2,29.2,12.3,29,12.5z"
}), React.createElement("path", {
  className: "st1",
  d: "M36.9,6.5c0.1,0,0.2,0,0.3,0.1c0.1,0.1,0.3,0.3,0.3,0.4C37.4,7.1,37.2,7.1,37,7c-0.1,0-0.1,0-0.2-0.1 c-0.1-0.1-0.1-0.2-0.2-0.3C36.7,6.6,36.8,6.5,36.9,6.5z"
}), React.createElement("path", {
  className: "st1",
  d: "M56.6,21.4c-0.3-0.6-0.5-1.1-0.4-1.8C56.5,20.1,56.6,20.7,56.6,21.4z"
}), React.createElement("path", {
  className: "st1",
  d: "M41.6,6c-0.4,0.1-0.7,0-0.9-0.3c0-0.1-0.1-0.1-0.1-0.2c0,0,0.1-0.1,0.1-0.1C41.1,5.4,41.5,5.7,41.6,6z"
}), React.createElement("path", {
  className: "st1",
  d: "M32.4,54.6c0.4-0.3,0.9-0.4,1.4-0.2C33.5,54.6,33.2,54.7,32.4,54.6z"
}), React.createElement("path", {
  className: "st1",
  d: "M22,17.1c-0.1-0.3,0.2-0.4,0.4-0.3c0.1,0,0.3,0.2,0.3,0.3c0.1,0.2-0.2,0.4-0.4,0.4 C22.1,17.4,21.9,17.3,22,17.1z"
}), React.createElement("path", {
  className: "st1",
  d: "M45.7,6.8c-0.4,0.1-0.9-0.3-0.9-0.7C45.2,6.1,45.5,6.4,45.7,6.8z"
}), React.createElement("path", {
  className: "st1",
  d: "M44.2,51c0.4-0.4,0.8-0.8,1.4-1C45.2,50.5,44.8,50.8,44.2,51z"
}), React.createElement("path", {
  className: "st1",
  d: "M49.5,8.8c0.5,0.2,0.7,0.5,0.9,1C50.1,9.8,49.6,9.4,49.5,8.8z"
}), React.createElement("path", {
  className: "st1",
  d: "M32.3,9.2c0.1,0.1,0.3,0.2,0.3,0.4c0.1,0.2-0.1,0.3-0.3,0.3c-0.2,0-0.4-0.2-0.4-0.3 C31.9,9.3,32,9.2,32.3,9.2z"
}), React.createElement("path", {
  className: "st1",
  d: "M24.8,14.9c-0.1-0.1-0.3-0.2-0.3-0.3c0-0.2,0.2-0.4,0.4-0.4c0.1,0,0.3,0.2,0.3,0.3 C25.2,14.7,25.1,14.8,24.8,14.9z"
}), React.createElement("path", {
  className: "st1",
  d: "M39.8,53.2c0.5-0.3,0.9-0.6,1.5-0.7c0,0,0,0.1,0,0.1c-0.5,0.2-1,0.5-1.5,0.7C39.8,53.3,39.8,53.3,39.8,53.2z "
}), React.createElement("path", {
  className: "st1",
  d: "M41.4,5.2c0.4-0.1,0.8,0.1,0.9,0.5C41.9,5.8,41.6,5.7,41.4,5.2z"
}), React.createElement("path", {
  className: "st1",
  d: "M19.3,19.9c0,0-0.1-0.1-0.1-0.2c0-0.2,0.1-0.4,0.3-0.4c0.1,0,0.3,0.2,0.3,0.3C19.8,19.8,19.7,20,19.3,19.9z"
}), React.createElement("path", {
  className: "st1",
  d: "M19.6,50.4c-0.3,0-0.6,0.1-0.8-0.2c-0.1-0.1-0.1-0.2-0.1-0.2c0-0.1,0.1-0.1,0.2-0.1 C19.3,49.9,19.5,50.1,19.6,50.4z"
}), React.createElement("path", {
  className: "st1",
  d: "M27.4,53.7c-0.3,0.2-1,0.2-1.1-0.1C26.6,53.4,27.1,53.5,27.4,53.7z"
}), React.createElement("path", {
  className: "st1",
  d: "M16.7,48.3c-0.5,0-0.6-0.1-0.8-0.5c0.2,0,0.3,0,0.5,0.1C16.5,47.9,16.8,48,16.7,48.3z"
}), React.createElement("path", {
  className: "st1",
  d: "M36.2,7.2c-0.3,0.1-0.5,0.1-0.7-0.1c-0.1,0-0.1-0.2-0.1-0.2c0-0.1,0.1-0.1,0.2-0.1 C35.9,6.6,36.2,6.8,36.2,7.2z"
}), React.createElement("path", {
  className: "st1",
  d: "M56.9,22c0.1,0.6,0.2,1.2,0.3,1.8c-0.1,0-0.1,0-0.2,0c-0.1-0.6-0.2-1.2-0.3-1.8C56.8,22,56.9,22,56.9,22z"
}), React.createElement("path", {
  className: "st1",
  d: "M55.4,37.7c0.2-0.6,0.4-1.2,0.6-1.8c0.1,0,0.1,0,0.2,0.1c-0.2,0.6-0.4,1.2-0.6,1.8 C55.4,37.8,55.4,37.8,55.4,37.7z"
}), React.createElement("path", {
  className: "st1",
  d: "M47.7,6.9c0.3,0.3,0.6,0.6,0.9,0.8C48.2,7.8,47.6,7.3,47.7,6.9z"
}), React.createElement("path", {
  className: "st1",
  d: "M46.1,6.4c-0.4,0-0.9-0.3-0.9-0.7C45.6,5.7,45.9,6,46.1,6.4z"
}), React.createElement("path", {
  className: "st1",
  d: "M43,5.4c-0.5,0.1-0.8-0.1-0.9-0.5C42.5,4.8,42.7,4.9,43,5.4z"
}), React.createElement("path", {
  className: "st1",
  d: "M50.6,45.6c0.4-0.5,0.7-0.9,1.1-1.4c0,0,0.1,0,0.1,0.1C51.5,44.8,51.1,45.2,50.6,45.6 C50.7,45.6,50.6,45.6,50.6,45.6z"
}), React.createElement("path", {
  className: "st1",
  d: "M48.2,48.1c0.4-0.4,0.8-0.8,1.2-1.3c0,0,0.1,0.1,0.1,0.1C49.2,47.4,48.8,47.8,48.2,48.1 C48.2,48.1,48.2,48.1,48.2,48.1z"
}), React.createElement("path", {
  className: "st1",
  d: "M31.7,54.5c-0.4,0.3-0.9,0.2-1.3,0.1C30.8,54.4,31.2,54.4,31.7,54.5z"
}), React.createElement("path", {
  className: "st1",
  d: "M53.7,13.6c-0.3-0.5-0.5-0.9-0.8-1.4c0,0,0.1-0.1,0.1-0.1c0.3,0.5,0.6,0.9,0.8,1.4 C53.8,13.5,53.7,13.5,53.7,13.6z"
}), React.createElement("path", {
  className: "st1",
  d: "M27.1,11.6c0.1,0.2,0.3,0.3,0.3,0.4c-0.1,0.1-0.2,0.3-0.3,0.3c-0.1,0-0.3-0.2-0.3-0.3 C26.8,11.9,27,11.8,27.1,11.6z"
}), React.createElement("path", {
  className: "st1",
  d: "M21.5,51.9c0.4-0.2,0.8,0,0.9,0.3C22,52.3,21.7,52.3,21.5,51.9z"
}), React.createElement("path", {
  className: "st1",
  d: "M30.6,9.9c-0.1-0.2-0.2-0.3-0.3-0.4c0.1-0.1,0.2-0.2,0.3-0.2c0.1,0,0.2,0.2,0.4,0.2 C30.9,9.7,30.8,9.8,30.6,9.9z"
}), React.createElement("path", {
  className: "st1",
  d: "M51.4,10.1c0.3,0.4,0.6,0.7,0.8,1.1C51.9,11.2,51.5,10.6,51.4,10.1z"
}), React.createElement("path", {
  className: "st1",
  d: "M34.5,6.8c0.2,0.2,0.3,0.3,0.4,0.4c-0.1,0.1-0.2,0.2-0.3,0.2c-0.2-0.1-0.3-0.2-0.4-0.3 C34.3,7,34.4,6.9,34.5,6.8z"
}), React.createElement("path", {
  className: "st1",
  d: "M41.4,52.7c0.5-0.3,0.9-0.5,1.4-0.8c0,0,0.1,0.1,0.1,0.1c-0.5,0.2-0.9,0.5-1.4,0.7 C41.5,52.7,41.4,52.7,41.4,52.7z"
}), React.createElement("path", {
  className: "st1",
  d: "M52.8,42.8c0.3-0.5,0.6-1,0.9-1.5c0,0,0.1,0.1,0.1,0.1c-0.3,0.5-0.6,1-0.9,1.5 C52.8,42.8,52.8,42.8,52.8,42.8z"
}), React.createElement("path", {
  className: "st1",
  d: "M47.2,49.3c-0.5,0.4-1,0.7-1.4,1c0,0,0,0,0-0.1C46.2,49.9,46.5,49.3,47.2,49.3z"
}), React.createElement("path", {
  className: "st1",
  d: "M43.5,5c-0.4,0.1-0.6-0.1-0.9-0.5C43,4.5,43.3,4.7,43.5,5z"
}), React.createElement("path", {
  className: "st1",
  d: "M16.2,24.7c0.1,0.1,0.2,0.2,0.2,0.3c0,0.1-0.2,0.3-0.3,0.3c-0.2,0.1-0.3-0.1-0.2-0.2c0-0.1,0.1-0.2,0.2-0.4 C16.1,24.7,16.1,24.7,16.2,24.7z"
}), React.createElement("path", {
  className: "st1",
  d: "M57,32c0.1-0.6,0.1-1.2,0.2-1.8c0,0,0.1,0,0.1,0c-0.1,0.6-0.1,1.2-0.2,1.8C57.1,32,57,32,57,32z"
}), React.createElement("path", {
  className: "st1",
  d: "M49.7,8.2c0.3,0.3,0.6,0.6,0.9,0.9C50.2,9.1,49.8,8.7,49.7,8.2z"
}), React.createElement("path", {
  className: "st1",
  d: "M13.3,43.6c-0.3,0-0.5-0.2-0.5-0.5C13.2,42.9,13.4,43.1,13.3,43.6z"
}), React.createElement("path", {
  className: "st1",
  d: "M54.4,14.3c0.2,0.5,0.4,0.9,0.7,1.4c0,0-0.1,0-0.1,0.1c-0.2-0.5-0.5-0.9-0.7-1.4 C54.3,14.4,54.3,14.3,54.4,14.3z"
}), React.createElement("path", {
  className: "st1",
  d: "M46.5,6c-0.5-0.1-0.7-0.4-0.9-0.7C45.9,5.4,46.2,5.6,46.5,6z"
}), React.createElement("path", {
  className: "st1",
  d: "M12.8,41.4c-0.2-0.2-0.3-0.4-0.4-0.5c0,0,0.2-0.2,0.2-0.2c0.1,0.1,0.3,0.2,0.4,0.4 C13,41.1,12.9,41.2,12.8,41.4z"
}), React.createElement("path", {
  className: "st1",
  d: "M57.4,26.2c0-0.5-0.1-1.1-0.1-1.6c0,0,0.1,0,0.1,0c0,0.5,0.1,1.1,0.1,1.6C57.5,26.2,57.5,26.2,57.4,26.2z"
}), React.createElement("path", {
  className: "st1",
  d: "M12.4,38.2c0.3,0.1,0.5,0.3,0.4,0.5c0,0.1-0.2,0.1-0.2,0.1C12.3,38.6,12.3,38.4,12.4,38.2z"
}), React.createElement("path", {
  className: "st1",
  d: "M38.9,3.8c0.2,0.1,0.5,0.2,0.8,0.3C39.3,4.4,39,4.3,38.9,3.8C38.8,3.9,38.8,3.9,38.9,3.8z"
}), React.createElement("path", {
  className: "st1",
  d: "M37.3,4.3c0.2,0.1,0.4,0.1,0.6,0.2c0,0,0.1,0.1,0.1,0.1c0,0.1-0.1,0.1-0.1,0.1C37.6,4.8,37.3,4.6,37.3,4.3z"
}), React.createElement("path", {
  className: "st1",
  d: "M13.2,45.2c0.5,0,0.6,0.1,0.6,0.5C13.4,45.7,13.3,45.5,13.2,45.2z"
}), React.createElement("path", {
  className: "st1",
  d: "M47.8,6.5c0.3,0.3,0.6,0.5,0.9,0.8c0,0,0,0-0.1,0.1C48.2,7.2,48,6.9,47.8,6.5C47.8,6.5,47.8,6.5,47.8,6.5z"
}), React.createElement("path", {
  className: "st1",
  d: "M38.8,4.5c-0.3,0-0.6,0-0.7-0.3C38.5,4.1,38.7,4.2,38.8,4.5z"
}), React.createElement("path", {
  className: "st1",
  d: "M43.8,4.8c-0.3-0.2-0.5-0.3-0.9-0.5C43.4,4.2,43.8,4.4,43.8,4.8z"
}), React.createElement("path", {
  className: "st1",
  d: "M12.2,35.8c0.1-0.1,0.2-0.2,0.2-0.2c0.1,0.1,0.2,0.2,0.3,0.3c0,0-0.1,0.1-0.2,0.2 C12.5,36,12.4,35.9,12.2,35.8z"
}), React.createElement("path", {
  className: "st1",
  d: "M40.3,3.9C40,4.1,39.6,4,39.5,3.6C39.7,3.7,40,3.8,40.3,3.9z"
}), React.createElement("path", {
  className: "st1",
  d: "M57.1,32.7c-0.1,0.5-0.2,1-0.3,1.5c0,0-0.1,0-0.1,0c0.1-0.5,0.2-1,0.3-1.5C57,32.7,57.1,32.7,57.1,32.7z"
}), React.createElement("path", {
  className: "st1",
  d: "M55.9,17.9c-0.2-0.5-0.3-0.9-0.5-1.4c0,0,0.1,0,0.1,0c0.2,0.5,0.3,0.9,0.5,1.4 C55.9,17.9,55.9,17.9,55.9,17.9z"
}), React.createElement("path", {
  className: "st1",
  d: "M32.9,7c0.2,0.1,0.4,0.2,0.5,0.2c-0.1,0.1-0.2,0.2-0.2,0.2C33,7.4,32.9,7.4,32.9,7z"
}), React.createElement("path", {
  className: "st1",
  d: "M24.1,53.4c0.4,0,0.7-0.1,1,0.2C24.7,53.6,24.4,53.8,24.1,53.4z"
}), React.createElement("path", {
  className: "st1",
  d: "M54.7,39.6c0.2-0.5,0.4-0.9,0.6-1.4c0,0,0.1,0,0.1,0.1C55.2,38.7,55,39.2,54.7,39.6 C54.8,39.6,54.7,39.6,54.7,39.6z"
}), React.createElement("path", {
  className: "st1",
  d: "M28.9,9.3c0.1,0.1,0.2,0.2,0.3,0.3C29.1,9.7,29,9.8,29,9.8c-0.1,0-0.2-0.1-0.3-0.2 C28.7,9.6,28.8,9.5,28.9,9.3z"
}), React.createElement("path", {
  className: "st1",
  d: "M12.4,32.9c0.3-0.1,0.4,0,0.4,0.3c0,0.1-0.1,0.2-0.2,0.2C12.3,33.3,12.5,33.1,12.4,32.9z"
}), React.createElement("path", {
  className: "st1",
  d: "M35.6,54.7c0.4-0.1,0.8-0.2,1.2-0.3c0,0,0,0.1,0,0.1c-0.4,0.1-0.8,0.2-1.2,0.3 C35.7,54.8,35.7,54.8,35.6,54.7z"
}), React.createElement("path", {
  className: "st1",
  d: "M31.5,7.4c0.1-0.3,0.3-0.2,0.5-0.1c0,0,0.1,0.2,0,0.2C31.8,7.6,31.7,7.5,31.5,7.4z"
}), React.createElement("path", {
  className: "st1",
  d: "M40.7,3.8c-0.3,0-0.6-0.1-0.8-0.3C40.3,3.3,40.6,3.5,40.7,3.8z"
}), React.createElement("path", {
  className: "st1",
  d: "M28.5,54.6c0.3,0,0.7,0,1,0c0,0,0,0.1,0,0.1C29.2,54.7,28.8,54.7,28.5,54.6C28.5,54.7,28.5,54.6,28.5,54.6z"
}), React.createElement("path", {
  className: "st1",
  d: "M46.5,5.6c-0.3-0.2-0.5-0.4-0.8-0.5c0,0,0.1-0.1,0.1-0.1c0.3,0.2,0.5,0.4,0.8,0.6 C46.6,5.5,46.6,5.6,46.5,5.6z"
}), React.createElement("path", {
  className: "st1",
  d: "M36.4,4.6c0.3,0,0.6-0.1,0.7,0.3C36.7,4.9,36.5,4.9,36.4,4.6z"
}), React.createElement("path", {
  className: "st1",
  d: "M44.2,4.4c-0.3-0.1-0.5-0.3-0.8-0.4C43.7,3.9,44,4.1,44.2,4.4z"
}), React.createElement("path", {
  className: "st1",
  d: "M44.4,51.3c-0.4,0.3-0.9,0.5-1.3,0.8c0,0,0-0.1,0-0.1C43.5,51.7,43.9,51.5,44.4,51.3 C44.4,51.3,44.4,51.3,44.4,51.3z"
}), React.createElement("path", {
  className: "st1",
  d: "M35.4,4.7c0.2,0,0.4,0.1,0.7,0.1C35.8,5.2,35.6,5.1,35.4,4.7z"
}), React.createElement("path", {
  className: "st1",
  d: "M35,54.9c-0.3,0.1-0.7,0.1-1,0.2c0,0,0-0.1,0-0.1c0.3-0.1,0.7-0.1,1-0.2C35,54.8,35,54.9,35,54.9z"
}), React.createElement("path", {
  className: "st1",
  d: "M16.9,22.1c-0.1,0.1-0.2,0.2-0.3,0.2c0-0.1-0.2-0.2-0.1-0.2c0-0.1,0.1-0.2,0.2-0.2 C16.7,21.9,16.8,22,16.9,22.1z"
}), React.createElement("path", {
  className: "st1",
  d: "M20,51.9c-0.2-0.1-0.4-0.2-0.7-0.3C19.7,51.5,19.8,51.5,20,51.9C20,51.8,20,51.9,20,51.9z"
}), React.createElement("path", {
  className: "st1",
  d: "M16.6,49.6c0.4,0,0.5,0.1,0.5,0.4C16.9,49.9,16.8,49.8,16.6,49.6C16.6,49.6,16.6,49.6,16.6,49.6z"
}), React.createElement("path", {
  className: "st1",
  d: "M40.5,3.1c0.3,0,0.5,0.1,0.7,0.3c0,0,0,0.1,0,0.1C40.9,3.4,40.7,3.3,40.5,3.1C40.5,3.2,40.5,3.1,40.5,3.1z"
}), React.createElement("path", {
  className: "st1",
  d: "M22.8,14.1c0.1,0.1,0.2,0.2,0.2,0.2c-0.1,0.1-0.2,0.2-0.3,0.2c0,0-0.2-0.1-0.2-0.1 C22.7,14.3,22.7,14.2,22.8,14.1z"
}), React.createElement("path", {
  className: "st1",
  d: "M49.8,7.8c0.3,0.3,0.5,0.6,0.8,0.9c0,0,0,0-0.1,0.1C50.2,8.4,50,8.1,49.8,7.8C49.7,7.8,49.7,7.8,49.8,7.8z"
}), React.createElement("path", {
  className: "st1",
  d: "M14.3,47.7c-0.2-0.1-0.3-0.3-0.5-0.4c0,0,0.1-0.1,0.1-0.1c0.2,0,0.4,0.1,0.5,0.4 C14.3,47.6,14.3,47.6,14.3,47.7z"
}), React.createElement("path", {
  className: "st1",
  d: "M34.4,5c0.3-0.2,0.4-0.1,0.6,0.1C34.8,5.3,34.6,5.3,34.4,5z"
}), React.createElement("path", {
  className: "st1",
  d: "M37.4,54.4c0.3-0.1,0.7-0.2,1-0.3c0,0,0,0.1,0,0.1c-0.3,0.1-0.7,0.2-1,0.4C37.4,54.4,37.4,54.4,37.4,54.4z"
}), React.createElement("path", {
  className: "st1",
  d: "M51.5,9.7c0.2,0.3,0.5,0.6,0.7,0.9c0,0,0,0-0.1,0.1C51.9,10.3,51.6,10,51.5,9.7C51.4,9.7,51.5,9.7,51.5,9.7z "
}), React.createElement("path", {
  className: "st1",
  d: "M41.5,3.3c-0.2-0.1-0.4-0.2-0.6-0.3c0,0,0-0.1,0.1-0.1c0.2,0.1,0.4,0.2,0.7,0.3C41.5,3.2,41.5,3.2,41.5,3.3z "
}), React.createElement("path", {
  className: "st1",
  d: "M25.2,12.2c-0.1-0.1-0.1-0.2-0.2-0.2c0.1-0.1,0.1-0.1,0.2-0.2c0,0,0.1,0.1,0.1,0.2 C25.4,12,25.3,12.1,25.2,12.2z"
}), React.createElement("path", {
  className: "st1",
  d: "M13,30.2c0,0.1,0,0.2,0,0.3c0,0-0.1,0-0.1,0.1c-0.1-0.1-0.2-0.2-0.2-0.3C12.8,30.2,12.9,30.1,13,30.2 C13,30.1,13,30.1,13,30.2z"
}), React.createElement("path", {
  className: "st1",
  d: "M19.9,16.9c0.1-0.1,0.2-0.2,0.3-0.2c0,0,0.1,0.1,0.2,0.2c-0.1,0.1-0.2,0.1-0.3,0.2C20,17,20,16.9,19.9,16.9z "
}), React.createElement("path", {
  className: "st1",
  d: "M27.3,54.7c-0.2,0-0.4-0.1-0.7-0.1c0,0,0-0.1,0-0.1c0.2,0,0.5,0,0.7,0.1C27.3,54.6,27.3,54.7,27.3,54.7z"
}), React.createElement("path", {
  className: "st1",
  d: "M32.3,55.2c0.3,0,0.6-0.1,0.9-0.1c0,0,0,0.1,0,0.1c-0.3,0-0.6,0.1-0.9,0.1C32.3,55.2,32.3,55.2,32.3,55.2z"
}), React.createElement("path", {
  className: "st1",
  d: "M43.7,3.5c0.2,0.1,0.4,0.3,0.6,0.4c0,0,0,0.1-0.1,0.1c-0.2-0.1-0.4-0.3-0.6-0.4C43.6,3.6,43.7,3.5,43.7,3.5z "
}), React.createElement("path", {
  className: "st1",
  d: "M47.9,6.1c0.2,0.2,0.4,0.4,0.7,0.6c0,0,0,0.1-0.1,0.1C48.3,6.6,48.1,6.4,47.9,6.1 C47.9,6.2,47.9,6.1,47.9,6.1z"
}), React.createElement("path", {
  className: "st1",
  d: "M33.4,5.1c0.2,0,0.3,0.1,0.6,0.1c-0.3,0.2-0.4,0.2-0.6,0C33.4,5.1,33.4,5.1,33.4,5.1z"
}))), React.createElement("g", {
  id: "TBPhcv.tif",
  className: "st3"
}, React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  className: "st1",
  d: "M33.5,51.3c0-0.3,0-0.6,0-0.8c0-0.3,0.2-0.5,0.5-0.6c0.5-0.3,1,0,1,0.5c0,0.4-0.1,0.7-0.4,1 c0.1,0,0.1,0,0.2,0c0.9,0,1.9,0,2.8,0c0.2,0,0.2,0,0.3-0.2c0.1-0.4,0.3-0.7,0.7-0.8c0.4-0.1,0.7,0.1,0.7,0.4c0,0.2,0,0.4,0,0.6 c0.9,0,1.9,0,2.8,0c-0.1-0.4,0-0.7,0.2-1c0.1-0.2,0.3-0.3,0.5-0.4c0.4-0.2,0.7,0,0.7,0.4c0,0.3-0.1,0.7-0.5,1.1"
}), React.createElement("path", {
  className: "st1",
  d: "M16.3,45.2c0.2-0.5,0.5-0.6,0.9-0.5c0.4,0.1,0.6,0.4,0.6,0.8c0,0.3-0.2,0.6-0.6,0.6 c-0.3,0.1-0.7-0.1-0.8-0.5c0,0,0-0.1-0.1-0.1C16.3,45.4,16.3,45.3,16.3,45.2z"
}), React.createElement("path", {
  className: "st1",
  d: "M41.6,28.5c0,1-0.5,1.6-1.3,1.7c-0.5,0.1-0.9-0.1-1.2-0.4c-0.8-0.6-1.1-1.4-0.9-2.3 c0.2-0.9,1.2-1.3,2.1-0.9C41.1,27,41.5,27.7,41.6,28.5z"
}), React.createElement("path", {
  className: "st1",
  d: "M37.1,31.5c0,0.6-0.3,1.1-0.9,1.4c-0.6,0.3-1.3,0.2-1.7-0.3c-0.6-0.6-0.9-1.3-0.6-2.1 c0.4-1,1.7-1.3,2.5-0.5C36.9,30.4,37.1,30.9,37.1,31.5z"
}), React.createElement("path", {
  className: "st1",
  d: "M36.2,25.7c0,1-0.9,1.6-1.9,1.3c-0.9-0.3-1.6-1.3-1.4-2.2c0.2-0.8,1.1-1.2,2-0.9 C35.6,24.2,36.2,25,36.2,25.7z"
}), React.createElement("path", {
  className: "st1",
  d: "M40.6,35.9c-0.5,0-0.8-0.2-1.1-0.5c-0.6-0.6-0.7-1.5-0.3-2.2c0.4-0.8,1.5-1,2.2-0.4 c0.7,0.6,0.9,1.8,0.3,2.5C41.3,35.7,41,35.9,40.6,35.9z"
}), React.createElement("path", {
  className: "st1",
  d: "M46.1,31.8c-0.1,0.2-0.1,0.5-0.3,0.8c-0.3,0.5-0.9,0.6-1.5,0.3c-0.5-0.3-0.8-0.8-0.9-1.3 c-0.1-0.4-0.1-0.8,0.1-1.2c0.3-0.7,1.2-1,1.8-0.4C45.8,30.3,46,30.9,46.1,31.8z"
}), React.createElement("path", {
  className: "st1",
  d: "M37.1,22.2c0-0.8,0.7-1.3,1.5-1.1c1.1,0.3,1.8,1.4,1.6,2.3c-0.2,0.5-0.7,0.9-1.3,0.8 C37.9,24,37.1,23.1,37.1,22.2z"
}), React.createElement("path", {
  className: "st1",
  d: "M28.5,30.1c-0.8,0-1.4-0.5-1.6-1.3c-0.1-0.7,0.2-1.3,0.9-1.5c1-0.3,2.2,0.7,2,1.7 C29.8,29.7,29.2,30.1,28.5,30.1z"
}), React.createElement("path", {
  className: "st1",
  d: "M44.1,27.1c-0.4,0-0.7-0.1-0.9-0.4c-0.6-0.5-1-1.2-0.9-2c0.1-0.7,0.7-1,1.4-0.8c0.8,0.3,1.2,0.9,1.4,1.7 c0.1,0.3,0.1,0.7-0.1,1C44.8,26.9,44.5,27.1,44.1,27.1z"
}), React.createElement("path", {
  className: "st1",
  d: "M32.1,34.6c0,0.7-0.6,1.3-1.3,1.4c-0.8,0.1-1.5-0.4-1.6-1.1c-0.1-0.6,0-1.2,0.6-1.6 c0.5-0.4,1.3-0.3,1.8,0.1C32,33.7,32.1,34.1,32.1,34.6z"
}), React.createElement("path", {
  className: "st1",
  d: "M36.5,38.6c0,0.4-0.2,0.8-0.5,1.1c-0.6,0.5-1.4,0.4-1.9-0.2c-0.5-0.7-0.4-1.7,0.3-2.2 c0.6-0.4,1.4-0.3,1.8,0.3C36.4,38,36.4,38.3,36.5,38.6C36.5,38.6,36.5,38.6,36.5,38.6z"
}), React.createElement("path", {
  className: "st1",
  d: "M29.2,24.3c-0.9,0-1.7-0.7-1.7-1.5c0-0.6,0.5-1.1,1.3-1.1c0.9,0,1.6,0.6,1.7,1.3 C30.6,23.7,30,24.3,29.2,24.3z"
}), React.createElement("path", {
  className: "st1",
  d: "M41.7,40c-0.1,0.7-0.6,1.4-1.2,1.5c-0.4,0.1-0.7,0-0.9-0.2c-0.8-0.7-0.6-2.2,0.4-2.6c0.5-0.2,1.1,0,1.3,0.4 C41.6,39.4,41.6,39.7,41.7,40z"
}), React.createElement("path", {
  className: "st1",
  d: "M32.5,20.2c-0.9,0-1.7-0.7-1.7-1.4c0-0.6,0.4-1,1-1c0.8,0,1.6,0.6,1.8,1.3C33.7,19.6,33.2,20.2,32.5,20.2z"
}), React.createElement("path", {
  className: "st1",
  d: "M46.5,38.6c0,0.5-0.2,1-0.6,1.3c-0.4,0.3-0.9,0.3-1.3-0.1c-0.5-0.6-0.5-1.8,0.2-2.3 c0.5-0.4,1.1-0.3,1.4,0.1C46.4,37.9,46.5,38.3,46.5,38.6z"
}), React.createElement("path", {
  className: "st1",
  d: "M24.3,32.3c0,0.7-0.6,1.2-1.3,1.2c-0.7,0-1.3-0.6-1.3-1.3c0-0.7,0.6-1.2,1.2-1.2 C23.7,31,24.3,31.5,24.3,32.3z"
}), React.createElement("path", {
  className: "st1",
  d: "M25.8,39.1c-0.7,0-1.3-0.6-1.3-1.3c0-0.7,0.6-1.2,1.2-1.2c0.7,0,1.3,0.6,1.3,1.2 C27.1,38.5,26.5,39.1,25.8,39.1z"
}), React.createElement("path", {
  className: "st1",
  d: "M23.5,26.1c0,0.6-0.6,1.2-1.2,1.2c-0.7,0-1.3-0.6-1.3-1.3c0-0.6,0.6-1.1,1.2-1.1 C22.9,24.9,23.5,25.5,23.5,26.1z"
}), React.createElement("path", {
  className: "st1",
  d: "M38.2,18c0,0.5-0.4,0.8-1,0.7c-0.8-0.1-1.4-0.6-1.6-1.3c-0.2-0.7,0.2-1.1,1-1C37.4,16.4,38.2,17.3,38.2,18z "
}), React.createElement("path", {
  className: "st1",
  d: "M49.6,34.7c0,0.4-0.1,0.7-0.3,1c-0.3,0.4-0.8,0.4-1.1,0.1c-0.6-0.5-0.7-1.7-0.2-2.4 c0.3-0.4,0.8-0.5,1.2-0.1C49.5,33.7,49.6,34.2,49.6,34.7z"
}), React.createElement("path", {
  className: "st1",
  d: "M31.1,42.2c0,0.4-0.2,0.7-0.6,1c-0.7,0.4-1.5,0-1.7-0.8c-0.2-0.9,0.7-1.6,1.6-1.4 C30.8,41.2,31.1,41.6,31.1,42.2z"
}), React.createElement("path", {
  className: "st1",
  d: "M23.4,19.6c0.7,0,1.3,0.5,1.3,1.2c0,0.6-0.5,1-1.2,1c-0.7,0-1.3-0.5-1.3-1.2C22.2,20,22.7,19.5,23.4,19.6z"
}), React.createElement("path", {
  className: "st1",
  d: "M40.9,18.4c0-0.5,0.3-0.7,0.8-0.6c0.8,0.2,1.6,1,1.6,1.8c0,0.5-0.3,0.8-0.8,0.7 C41.8,20,40.9,19.1,40.9,18.4z"
}), React.createElement("path", {
  className: "st1",
  d: "M50,29.3c0,0.1-0.1,0.4-0.2,0.6c-0.2,0.3-0.5,0.4-0.8,0.2c-0.1,0-0.2-0.1-0.2-0.2c-0.6-0.6-0.8-1.4-0.6-2.2 c0.1-0.5,0.6-0.7,1-0.3C49.8,27.9,50,28.5,50,29.3z"
}), React.createElement("path", {
  className: "st1",
  d: "M34.9,43.7c0.5,0,0.9,0.4,1,0.9c0,0.5-0.2,0.9-0.6,1.2c-0.5,0.4-1.2,0.2-1.4-0.3 C33.4,44.7,34,43.7,34.9,43.7z"
}), React.createElement("path", {
  className: "st1",
  d: "M45.6,22.3c0-0.1,0.1-0.3,0.1-0.4c0.1-0.2,0.3-0.3,0.6-0.2c0.1,0,0.2,0.1,0.3,0.1c0.8,0.5,1.2,1.2,1.1,2 c0,0.5-0.4,0.7-0.9,0.4c-0.7-0.3-1-0.8-1.2-1.5C45.6,22.7,45.6,22.5,45.6,22.3z"
}), React.createElement("path", {
  className: "st1",
  d: "M40.8,45.6c0,0.5-0.3,1-0.8,1.2c-0.5,0.2-0.9,0.1-1.1-0.4c-0.3-0.6,0-1.4,0.6-1.7c0.6-0.3,1.2-0.1,1.3,0.6 C40.7,45.4,40.8,45.5,40.8,45.6z"
}), React.createElement("path", {
  className: "st1",
  d: "M26.1,15.5c0.5,0,0.9,0.2,1.2,0.6c0.4,0.6,0,1.3-0.8,1.3c-0.5,0-1-0.2-1.3-0.6c-0.2-0.3-0.3-0.6-0.1-0.9 C25.4,15.6,25.7,15.5,26.1,15.5z"
}), React.createElement("path", {
  className: "st1",
  d: "M17.4,37c0-0.6,0.4-1,1-1c0.6,0,1.1,0.4,1.1,1c0,0.6-0.4,1-1,1C17.8,38,17.4,37.5,17.4,37z"
}), React.createElement("path", {
  className: "st1",
  d: "M43.7,45.2c0-0.5,0.2-1,0.6-1.3c0.5-0.3,1-0.1,1.1,0.4c0.1,0.6,0,1.1-0.5,1.5c-0.2,0.2-0.5,0.4-0.8,0.3 c-0.4-0.1-0.4-0.4-0.5-0.7C43.7,45.3,43.7,45.2,43.7,45.2z"
}), React.createElement("path", {
  className: "st1",
  d: "M22.6,42c0,0.5-0.5,1-1,1c-0.5,0-1-0.5-1-1c0-0.5,0.5-1,1-0.9C22.1,41,22.6,41.4,22.6,42z"
}), React.createElement("path", {
  className: "st1",
  d: "M30.5,14.8c-0.6,0-1.2-0.4-1.4-0.8c-0.2-0.5,0-0.9,0.6-0.9c0.6-0.1,1.4,0.4,1.5,0.9 C31.4,14.5,31.1,14.8,30.5,14.8z"
}), React.createElement("path", {
  className: "st1",
  d: "M47.9,42.6c0-0.5,0.1-0.9,0.5-1.3c0.4-0.4,0.9-0.3,1,0.2c0.2,0.6,0.1,1.2-0.4,1.7c-0.4,0.4-0.8,0.3-1-0.2 C47.9,42.9,47.9,42.7,47.9,42.6z"
}), React.createElement("path", {
  className: "st1",
  d: "M24.7,46c0-0.5,0.4-1,1-1c0.5,0,0.9,0.4,0.9,0.9c0,0.5-0.4,1-1,1C25.1,46.9,24.7,46.5,24.7,46z"
}), React.createElement("path", {
  className: "st1",
  d: "M16.4,20.2c0-0.5,0.4-0.9,0.9-0.9c0.6,0,1,0.4,1,0.8c0,0.5-0.4,0.9-1,0.9C16.7,21,16.4,20.7,16.4,20.2z"
}), React.createElement("path", {
  className: "st1",
  d: "M35.1,14c-0.6,0-1.3-0.5-1.5-1.1c-0.1-0.4,0.1-0.6,0.5-0.6c0.6,0,1.3,0.5,1.6,1C35.9,13.7,35.7,14,35.1,14z "
}), React.createElement("path", {
  className: "st1",
  d: "M50.8,38c0.1-0.3,0.2-0.6,0.3-0.9c0.1-0.2,0.2-0.3,0.5-0.3c0.2,0,0.3,0.2,0.4,0.3c0.3,0.6,0.3,1.2-0.1,1.8 c-0.1,0.1-0.3,0.3-0.4,0.3c-0.2,0-0.4-0.2-0.4-0.3C50.9,38.6,50.9,38.3,50.8,38z"
}), React.createElement("path", {
  className: "st1",
  d: "M29,48.9c0-0.3,0.1-0.5,0.5-0.8c0.5-0.3,1.1-0.1,1.2,0.5c0.1,0.4-0.1,0.9-0.5,1.1 C29.6,49.9,29,49.6,29,48.9z"
}), React.createElement("path", {
  className: "st1",
  d: "M19.7,15.1c0.5,0,1,0.4,1,0.8c0,0.4-0.4,0.7-0.9,0.7c-0.5,0-1-0.4-1-0.8C18.8,15.4,19.2,15.1,19.7,15.1z"
}), React.createElement("path", {
  className: "st1",
  d: "M40.2,14.9c-0.6,0-1.5-0.8-1.6-1.3c0-0.3,0.2-0.5,0.5-0.4c0.6,0.1,1.4,0.7,1.5,1.3 C40.7,14.7,40.5,14.9,40.2,14.9z"
}), React.createElement("path", {
  className: "st1",
  d: "M53.2,32.7c0,0.2,0,0.4-0.1,0.6c-0.1,0.1-0.2,0.3-0.3,0.4c-0.2,0.1-0.4-0.1-0.4-0.3 C52.2,33,52,32.6,52,32.2c0-0.3,0-0.5,0.1-0.8c0-0.1,0.2-0.3,0.3-0.3c0.1,0,0.3,0.1,0.4,0.2C53,31.6,53.1,32.1,53.2,32.7z"
}), React.createElement("path", {
  className: "st1",
  d: "M45.3,17.2c0,0.2-0.2,0.4-0.4,0.3c-0.2-0.1-0.5-0.2-0.7-0.4c-0.4-0.3-0.6-0.7-0.8-1.1 c-0.1-0.3,0.1-0.4,0.4-0.4C44.5,15.7,45.3,16.6,45.3,17.2z"
}), React.createElement("path", {
  className: "st1",
  d: "M52.2,27c-0.1,0.1-0.1,0.3-0.3,0.4c-0.2,0.1-0.4-0.1-0.5-0.2c-0.4-0.5-0.6-1.1-0.6-1.7 c0-0.1,0.1-0.3,0.2-0.3c0.1,0,0.3,0.1,0.4,0.1C51.9,25.7,52.1,26.3,52.2,27z"
}), React.createElement("path", {
  className: "st1",
  d: "M49.4,21.4c0,0.4-0.2,0.5-0.5,0.3c-0.7-0.4-1.1-1-1.1-1.8c0-0.3,0.2-0.3,0.4-0.2c0.1,0,0.2,0.1,0.2,0.1 C49,20.3,49.3,20.8,49.4,21.4z"
}), React.createElement("path", {
  className: "st1",
  d: "M22.9,13.3c-0.3,0-0.6-0.1-0.8-0.4c-0.3-0.4-0.1-0.8,0.4-0.9c0.4-0.1,0.9,0.1,1.1,0.4 c0.1,0.2,0.2,0.4,0.1,0.6C23.5,13.1,23.2,13.3,22.9,13.3z"
}), React.createElement("path", {
  className: "st1",
  d: "M16.4,32.3c0-0.7,0-1.3,0-2c0.4,0,0.7,0.1,0.9,0.4c0.3,0.4,0.3,0.8,0,1.2C17.1,32.1,16.8,32.3,16.4,32.3z"
}), React.createElement("path", {
  className: "st1",
  d: "M47.5,48.5c-0.1,0.5-0.3,0.9-0.6,1.2c-0.1,0.1-0.3,0.2-0.5,0.1c-0.1-0.1-0.2-0.3-0.2-0.4 c0-0.5,0.2-0.8,0.5-1.2c0.1-0.1,0.3-0.3,0.5-0.2C47.3,48.1,47.4,48.3,47.5,48.5z"
}), React.createElement("path", {
  className: "st1",
  d: "M26.4,11.1c-0.3,0-0.6-0.2-0.8-0.5c-0.1-0.2-0.2-0.3-0.1-0.5c0.1-0.2,0.3-0.2,0.5-0.2 c0.4,0,0.7,0.1,0.9,0.4c0.2,0.2,0.3,0.4,0.1,0.6C27,11.1,26.8,11.1,26.4,11.1z"
}), React.createElement("path", {
  className: "st1",
  d: "M20.4,49.3c0-0.4,0.3-0.7,0.7-0.6c0.4,0,0.7,0.3,0.7,0.7c0,0.4-0.3,0.7-0.7,0.7 C20.7,50,20.4,49.7,20.4,49.3z"
}), React.createElement("path", {
  className: "st1",
  d: "M49.7,46.5c0-0.5,0.1-0.8,0.4-1.2c0.1-0.1,0.3-0.2,0.4-0.2c0.1,0.1,0.2,0.2,0.2,0.4c0,0.4-0.1,0.9-0.4,1.2 C50.3,46.9,50.1,47,50,47C49.7,47,49.8,46.7,49.7,46.5C49.7,46.5,49.7,46.5,49.7,46.5z"
}), React.createElement("path", {
  className: "st1",
  d: "M30.5,10.1C30,10,29.6,9.8,29.3,9.4c-0.1-0.1-0.1-0.3,0-0.4c0.1-0.1,0.3-0.2,0.4-0.1c0.4,0,0.8,0.2,1.1,0.5 c0.1,0.1,0.1,0.3,0.1,0.4C30.8,10,30.6,10,30.5,10.1z"
}), React.createElement("path", {
  className: "st1",
  d: "M53.4,41.8c0,0.4-0.1,0.8-0.3,1.1c-0.1,0.1-0.2,0.2-0.3,0.2c-0.1,0-0.2-0.1-0.2-0.2c-0.1-0.5,0-1,0.2-1.5 c0.1-0.1,0.2-0.1,0.3-0.2c0.1,0.1,0.2,0.2,0.2,0.3C53.5,41.6,53.4,41.7,53.4,41.8z"
}), React.createElement("path", {
  className: "st1",
  d: "M34.6,10.1c-0.6-0.1-1-0.3-1.3-0.8c-0.1-0.1-0.1-0.2,0-0.3c0-0.1,0.2-0.1,0.3-0.1c0.5,0.1,0.9,0.3,1.2,0.7 c0.1,0.1,0.1,0.2,0,0.3C34.9,10,34.7,10,34.6,10.1z"
}), React.createElement("path", {
  className: "st1",
  d: "M16.4,24.6c0.4,0.1,0.8,0.4,0.8,0.9c0,0.4-0.3,0.8-0.8,0.9C16.4,25.7,16.4,25.1,16.4,24.6z"
}), React.createElement("path", {
  className: "st1",
  d: "M54.9,37.2c-0.1,0.2-0.1,0.5-0.2,0.8c0,0.1-0.1,0.1-0.2,0.2c-0.1-0.1-0.1-0.1-0.2-0.2 c-0.2-0.5-0.2-1.1,0-1.6c0-0.1,0.1-0.2,0.2-0.2c0.1,0.1,0.2,0.2,0.2,0.3C54.9,36.7,54.9,36.9,54.9,37.2z"
}), React.createElement("path", {
  className: "st1",
  d: "M39,11.1c0,0-0.1,0-0.1,0c-0.5-0.2-0.9-0.5-1.2-0.9c0-0.1-0.1-0.2,0-0.3c0,0,0.2-0.1,0.3,0 c0.5,0.1,1,0.5,1.3,0.9C39.3,11,39.2,11.1,39,11.1z"
}), React.createElement("path", {
  className: "st1",
  d: "M17.8,11.3c-0.3,0-0.6-0.2-0.6-0.5c0-0.3,0.3-0.5,0.6-0.5c0.3,0,0.6,0.2,0.6,0.5 C18.4,11.1,18.2,11.3,17.8,11.3z"
}), React.createElement("path", {
  className: "st1",
  d: "M54.9,32.5c-0.1-0.1-0.1-0.1-0.2-0.2c-0.2-0.5-0.3-1-0.3-1.6c0-0.1,0.1-0.2,0.1-0.3 c0.1,0.1,0.2,0.2,0.2,0.3c0.1,0.5,0.2,0.9,0.3,1.4C55.1,32.2,55,32.4,54.9,32.5C54.9,32.5,54.9,32.5,54.9,32.5z"
}), React.createElement("path", {
  className: "st1",
  d: "M43.6,13.3c-0.1,0-0.2,0.1-0.2,0.1c-0.6-0.2-1-0.6-1.3-1.2C42,12,42.1,12,42.2,12c0.2,0.1,0.4,0.2,0.6,0.3 c0.2,0.2,0.4,0.4,0.6,0.6C43.5,13,43.5,13.1,43.6,13.3z"
}), React.createElement("path", {
  className: "st1",
  d: "M46.3,15.2c0.1,0,0.2,0,0.2,0.1c0.5,0.3,0.8,0.7,1,1.2c0,0.1,0,0.1,0,0.2c-0.1,0-0.1,0-0.2,0 c-0.5-0.3-0.9-0.8-1.1-1.3C46.3,15.3,46.3,15.3,46.3,15.2z"
}), React.createElement("path", {
  className: "st1",
  d: "M53.7,26.6c-0.4-0.1-1-1.5-0.7-1.9C53.4,24.9,53.9,26.1,53.7,26.6z"
}), React.createElement("path", {
  className: "st1",
  d: "M51.2,21.2c-0.5-0.2-1.1-1.3-1-1.7C50.5,19.6,51.3,20.7,51.2,21.2z"
}), React.createElement("path", {
  className: "st1",
  d: "M21.6,8.7c-0.1,0.1-0.2,0.2-0.3,0.2c-0.3,0.1-0.6,0-0.8-0.2c-0.1-0.1-0.1-0.3,0-0.4 c0.1-0.2,0.4-0.2,0.7-0.1C21.4,8.2,21.6,8.4,21.6,8.7z"
}), React.createElement("path", {
  className: "st1",
  d: "M23.9,6.7c0.4,0,0.6,0.1,0.8,0.3c0.2,0.2,0.1,0.4-0.2,0.4c-0.3,0-0.5-0.1-0.7-0.2c-0.1-0.1-0.1-0.2-0.1-0.3 C23.7,6.8,23.8,6.8,23.9,6.7z"
}), React.createElement("path", {
  className: "st1",
  d: "M50.7,49.9c0.1-0.4,0.2-0.8,0.5-1.1c0.1-0.1,0.2-0.1,0.2-0.1c0,0.1,0.1,0.2,0.1,0.2c-0.1,0.4-0.2,0.7-0.5,1 c0,0-0.1,0.1-0.2,0.1C50.8,50.1,50.8,50,50.7,49.9z"
}), React.createElement("path", {
  className: "st1",
  d: "M27.7,6.8c-0.4,0-0.6-0.2-0.9-0.4c0-0.1-0.1-0.2-0.1-0.2c0.1-0.1,0.2-0.1,0.2-0.1c0.3,0.1,0.5,0.2,0.8,0.3 c0.1,0,0.1,0.2,0.1,0.2C27.9,6.7,27.8,6.7,27.7,6.8z"
}), React.createElement("path", {
  className: "st1",
  d: "M53.6,46.3c-0.2-0.4,0.1-1.2,0.4-1.4C54.2,45.1,54,46.1,53.6,46.3z"
}), React.createElement("path", {
  className: "st1",
  d: "M30.2,6.2c0.4-0.1,1,0.2,1.2,0.5C31.1,6.9,30.3,6.5,30.2,6.2z"
}), React.createElement("path", {
  className: "st1",
  d: "M33.9,6.8c0.4-0.1,1.1,0.4,1.2,0.7C34.8,7.5,34.1,7.1,33.9,6.8z"
}), React.createElement("path", {
  className: "st1",
  d: "M55.5,41.5c-0.1-0.5,0-1.2,0.2-1.5C55.8,40.3,55.7,41.2,55.5,41.5z"
}), React.createElement("path", {
  className: "st1",
  d: "M37.9,8.2c0.5,0.2,1,0.4,1.3,0.8C38.9,9,38.1,8.6,37.9,8.2z"
}), React.createElement("path", {
  className: "st1",
  d: "M42.3,10.5c0.4,0.3,0.7,0.6,1.1,0.9C43.1,11.4,42.4,10.9,42.3,10.5C42.2,10.5,42.3,10.5,42.3,10.5z"
}), React.createElement("path", {
  className: "st1",
  d: "M56.2,34.6c0,0.5,0,1,0,1.5c0,0-0.1,0-0.1,0c0-0.5,0-1-0.1-1.5C56.1,34.6,56.2,34.6,56.2,34.6z"
}), React.createElement("path", {
  className: "st1",
  d: "M16.6,6.9c0.2,0,0.3,0.1,0.3,0.3c0,0.2-0.2,0.2-0.4,0.2c-0.2,0-0.2-0.1-0.2-0.3C16.4,6.9,16.4,6.9,16.6,6.9 z"
}), React.createElement("path", {
  className: "st1",
  d: "M19.5,5.9c-0.2-0.1-0.3-0.2-0.4-0.3c0.1-0.1,0.2-0.1,0.3-0.2c0.2,0,0.4,0,0.4,0.2 C19.7,5.7,19.6,5.7,19.5,5.9z"
}), React.createElement("path", {
  className: "st1",
  d: "M46.4,13.7c0.3,0.4,0.7,0.7,1,1.1C47.1,14.7,46.5,14.1,46.4,13.7C46.4,13.7,46.4,13.7,46.4,13.7z"
}), React.createElement("path", {
  className: "st1",
  d: "M50.9,19.1c-0.3-0.4-0.5-0.8-0.8-1.2c0,0,0.1,0,0.1-0.1C50.5,18.3,50.7,18.7,50.9,19.1 C51,19.1,50.9,19.1,50.9,19.1z"
}), React.createElement("path", {
  className: "st1",
  d: "M55.6,30c-0.1-0.5-0.2-0.9-0.3-1.4c0,0,0.1,0,0.1,0c0.1,0.5,0.2,0.9,0.3,1.4C55.6,30,55.6,30,55.6,30z"
}), React.createElement("path", {
  className: "st1",
  d: "M21.6,4.5c0.3-0.1,0.5,0,0.7,0.2C22.1,4.9,21.8,4.8,21.6,4.5z"
}), React.createElement("path", {
  className: "st1",
  d: "M53.3,23c0.2,0.4,0.4,0.8,0.6,1.2c0,0-0.1,0-0.1,0C53.6,23.9,53.4,23.5,53.3,23C53.2,23,53.3,23,53.3,23z"
}), React.createElement("path", {
  className: "st1",
  d: "M24.2,4c0.2,0.1,0.5,0.2,0.7,0.2C24.6,4.4,24.3,4.4,24.2,4C24.1,4.1,24.2,4.1,24.2,4z"
}), React.createElement("path", {
  className: "st1",
  d: "M53.8,48.5c-0.1,0.3-0.2,0.6-0.4,0.9c0,0-0.1,0-0.1,0c0.1-0.3,0.2-0.6,0.4-0.9 C53.8,48.5,53.8,48.5,53.8,48.5z"
}), React.createElement("path", {
  className: "st1",
  d: "M26.8,4.1c0.3,0.1,0.5,0.2,0.8,0.3c0,0,0,0.1,0,0.1c-0.3-0.1-0.5-0.2-0.8-0.3C26.8,4.1,26.8,4.1,26.8,4.1z"
}), React.createElement("path", {
  className: "st1",
  d: "M30.6,4.9c-0.3-0.1-0.5-0.2-0.8-0.3c0,0,0-0.1,0-0.1C30.1,4.6,30.4,4.7,30.6,4.9 C30.7,4.8,30.7,4.9,30.6,4.9z"
}), React.createElement("path", {
  className: "st1",
  d: "M34.1,5.8c-0.3-0.1-0.5-0.2-0.8-0.4c0,0,0,0,0-0.1C33.6,5.5,33.9,5.7,34.1,5.8C34.2,5.8,34.1,5.8,34.1,5.8z "
})))));

var SvgWmgrLogoIcon = function SvgWmgrLogoIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    viewBox: "0 0 291.7 57.3",
    style: {
      enableBackground: "new 0 0 291.7 57.3"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgWmgrLogoIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/wmgr_logo_icon.2b84fe42.svg";
export { ForwardRef as ReactComponent };